<template>
    <div class="document-view-container d-flex">

        <!-- Área de Contenido Principal -->
        <v-main class="document-content-area d-flex flex-column pa-0">
            <!--- Header -->
            <div v-if="false" class="d-flex flex-column justify-space-between align-center"
                style="width: 100%; background-color: #ffffffb5">

            </div>

            <!-- Contenido del bloque seleccionado -->
            <div class="content-wrapper">

                <!-- Mensajes de Carga o Error de Estructura -->
                <div v-if="(!structureLoading && structureError) && !showLimitExceededAlert" class="text-center my-6">
                    <v-alert type="error" outlined>
                        {{ structureError }}
                    </v-alert>
                    <v-btn color="primary" class="mt-4" @click="fetchStructureAndContent">
                        Reintentar
                    </v-btn>
                </div>
                <div v-else-if="!structureLoading && (!blocks || blocks.length === 0)" class="text-center my-10">
                    <v-alert type="info" outlined>
                        No se encontró contenido estructurado para este documento.
                    </v-alert>
                </div>

                <!-- Componente del Bloque Seleccionado -->
                <div v-else-if="selectedBlockData" class="content-container" :class="contentContainerClass">

                    <v-icon v-if="selectedSubItemType !== 'pdf'" style="position: absolute; right: 16px; z-index: 200;"
                        :style="`top: ${selectedSubItemType === 'pdf-section' ? '12px' : '20px'};`"
                        @click="selectPdfViewer">mdi-close</v-icon>


                    <div class="content-card" style="width: 100%;">
                        <div v-if="selectedSubItemType === 'pdf'"
                            style="position: relative; border-top: 1px solid #E3E5EB;">

                            <div class="d-flex flex-column align-center justify-space-between"
                                style="width: 100%; max-width: 900px; margin: 0 auto;">

                                <!-- Barra de navegación de migas de pan -->
                                <div v-if="documentDetails && documentDetails.subject_name"
                                    class="breadcrumb font-rubik px-3 py-1 d-flex align-center mt-4"
                                    style="width: 100%;">
                                    <v-btn icon small color="grey darken-1" @click="goBackToSubject" class="">
                                        <lucide-home :size="13" />
                                    </v-btn>
                                    <span class="mr-2 grey--text font-rubik">/</span>
                                    <span @click="goBackToSubject"
                                        class="font-weight-medium font-rubik text-truncate d-inline-block"
                                        style="font-size: 14px; cursor: pointer; display: inline-block;"
                                        :style="'max-width: ' + ($vuetify.breakpoint.xs ? '200px' : 'fit-content') + '!important'"
                                        :title="documentDetails.subject_name">{{ documentDetails.subject_name
                                        }}</span>
                                    <span class="mx-2 grey--text font-rubik">/</span>
                                    <span class="font-weight-bold font-rubik text-truncate d-inline-block"
                                        style="font-size: 14px; display: inline-block;"
                                        :style="'max-width: ' + ($vuetify.breakpoint.xs ? '200px' : 'fit-content') + '!important'"
                                        :title="documentDetails.name">{{ documentDetails.name }}</span>
                                </div>

                                <div v-if="selectedSubItemType == 'pdf'" class="content-header px-4 py-4"
                                    style="width: 100%; min-height: 100px;">

                                    <div class="d-flex align-center justify-space-between">
                                        <div class="d-flex align-start">
                                            <div v-if="!$vuetify.breakpoint.xs">
                                                <!-- Imagen de vista previa o icono -->
                                                <div v-if="documentDetails && documentDetails.preview_image"
                                                    class="mr-4">
                                                    <v-img :src="documentDetails.preview_image" contain class="rounded"
                                                        style="width: 110px !important; height: 150px; border: 1px solid #E3E5EB; background-color: white;" />
                                                </div>
                                                <div v-else-if="!isLoading" class="mr-4"
                                                    style="width: 60px; height: 80px; display: flex; align-items: center; justify-content: center; background-color: #f0f0f0; border-radius: 8px; border: 1px solid #e0e0e0;">
                                                    <svg v-if="documentDetails.mimeType === 'application/pdf' || documentDetails.mimeType === 'text/plain'"
                                                        xmlns="http://www.w3.org/2000/svg" width="40" height="55"
                                                        viewBox="0 0 512 512">
                                                        <g>
                                                            <path
                                                                d="M104 0C86.328 0 72 14.328 72 32v448c0 17.672 14.328 32 32 32h304c17.672 0 32-14.328 32-32V128L312 0H104z"
                                                                fill="#e2e7f0" />
                                                            <path d="M344 128h96L312 0v96c0 17.672 14.328 32 32 32z"
                                                                fill="#c9d5e3" />
                                                        </g>
                                                    </svg>
                                                    <Images v-else-if="documentDetails.mimeType === 'image/collection'"
                                                        :width="40" :height="55" />
                                                    <Presentation
                                                        v-else-if="documentDetails.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'"
                                                        :width="40" :height="55" />
                                                </div>
                                                <v-skeleton-loader v-else type="image" width="60" height="80"
                                                    style="border-radius: 8px;"></v-skeleton-loader>
                                            </div>

                                            <div class="d-flex flex-column align-start">

                                                <div class="d-flex align-center" style="width: 100%;">
                                                    <h1 class="font-rubik font-weight-medium mt-0"
                                                        style="font-size: 1.3rem !important; line-height: 1 !important; flex: 1;">
                                                        {{ documentDetails.name }}
                                                    </h1>

                                                </div>
                                                <div class="mt-2">
                                                    <p class="font-rubik"
                                                        style="font-size: 12px; line-height: 1.4 !important; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                                                        v-show="!showFullDescription">
                                                        {{ documentDetails.description }}
                                                    </p>
                                                </div>

                                                <!-- Información de autor y fecha -->
                                                <div class="d-flex align-center mt-3">
                                                    <div v-if="documentDetails.user_name"
                                                        class="d-flex align-center rounded-lg px-2 py-1 mr-2"
                                                        style="background: #F7F7F7;">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            viewBox="0 0 24 24" fill="none" stroke="rgb(105 105 105)"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            class="mr-2 lucide lucide-circle-user-round-icon lucide-circle-user-round">
                                                            <path d="M18 20a6 6 0 0 0-12 0" />
                                                            <circle cx="12" cy="10" r="4" />
                                                            <circle cx="12" cy="12" r="10" />
                                                        </svg>
                                                        <span class="font-rubik"
                                                            style="color: rgb(105 105 105) !important; font-size: 0.8rem;">{{
                                                                documentDetails.user_name }}</span>
                                                    </div>
                                                    <div v-if="documentDetails.created_at"
                                                        class="d-flex align-center rounded-lg px-2 py-1"
                                                        style="background: #F7F7F7;">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            viewBox="0 0 24 24" fill="none" stroke="rgb(105 105 105)"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" class="mr-2">
                                                            <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                                                            <line x1="16" x2="16" y1="2" y2="6" />
                                                            <line x1="8" x2="8" y1="2" y2="6" />
                                                            <line x1="3" x2="21" y1="10" y2="10" />
                                                        </svg>
                                                        <span class="font-rubik"
                                                            style="color: rgb(105 105 105) !important; font-size: 0.8rem;">{{
                                                                formatDate(documentDetails.created_at) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <pdf-viewer-block v-if="documentDetails && documentDetails.pdfUrl" ref="pdfViewerBlock"
                                :is-pdf-loading.sync="isPdfLoading" :document-id="documentId"
                                :pdf-url="documentDetails.pdfUrl" :block-id="selectedBlockData.id" :page-start="1"
                                :block-unique-id="selectedBlockData.uniqueId" :block-name="selectedBlockData.name"
                                style="border-top: 1px solid #E3E5EB; padding-bottom: 100px;"
                                :nav-width="isNavVisible ? navDrawerWidth : 0" />

                                <v-btn v-if="canStartStudy && $vuetify.breakpoint.smAndDown && !isNavVisible" color="primary" @click="navigateToNextBlock"
                                style="position: fixed; bottom: 90px; z-index: 103; "
                                :style="$vuetify.breakpoint.xs ? 'width: calc(100vw - 40px); left: 20px;' : 'width: fit-content; left: 50%; transform: translateX(-50%);'"
                                    class="regular-btn-primary font-rubik">
                                    Empezar (explicaciones, quizs, flashcards)

                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="ml-2 lucide lucide-arrow-right-icon lucide-arrow-right">
                                        <path d="M5 12h14" />
                                        <path d="m12 5 7 7-7 7" />
                                    </svg>
                                </v-btn>


                            <!-- Input Area -->
                            <div v-if="showInputChat && (activeTab == 0 || !isNavVisible)"
                                class="input-area d-flex align-center px-2 py-1 white rounded-lg shadow"
                                style="height: 50px !important; position: fixed; bottom: 16px; z-index: 103; box-shadow: 0 3px 0 #dadada !important; border: 1px solid #e9e9e9 !important;"
                                :style="`width: calc(100vw - ${$vuetify.breakpoint.xs ? 40 : (isNavVisible ? (navDrawerWidth + 150) : 40)}px); max-width: 600px !important; left: ${isNavVisible ? `calc((100vw - ${navDrawerWidth}px) / 2)` : '50%'}; transform: translateX(-50%);`">
                                <div class="d-flex" style="position: relative; width: 100%;">
                                    <v-textarea v-model="chatInput" placeholder="Pregunta lo que quieras..." rows="1"
                                        :max-rows="$vuetify.breakpoint.xs ? 1 : 4" :auto-grow="!$vuetify.breakpoint.xs"
                                        dense hide-details outlined class=" elevation-0" solo flat
                                        @keydown.enter.prevent="handleEnterKey" :disabled="isAiResponding"
                                        ref="chatTextarea" style="flex: 1; max-height: 100%;"></v-textarea>
                                    <v-btn icon color="primary"
                                        :class="{ 'pulse-animation': chatInput.trim().length > 0 }"
                                        @click="sendChatMessage" :disabled="!chatInput.trim() || isAiResponding"
                                        class="send-button">
                                        <v-icon color="white">mdi-arrow-up</v-icon>
                                    </v-btn>
                                </div>
                            </div>


                            <!-- Blur effect -->
                            <div v-if="showInputChat && (activeTab == 0 || !isNavVisible)" class="blur-effect"></div>




                        </div>
                        <div v-else-if="selectedSubItemType === 'pdf-section'"
                            style="width: 100%; padding-bottom: 120px !important;">
                            <div class="section-header mx-auto" :class="{ 'pa-4 py-4': !$vuetify.breakpoint.xs }"
                                style="max-width: 800px; margin-bottom: 20px;">
                                <h3 class="font-rubik font-weight-medium">{{ selectedBlockData.name }}</h3>
                                <p v-if="selectedBlockData.pageStart && selectedBlockData.pageEnd && selectedBlockData.pageStart !== selectedBlockData.pageEnd"
                                    class="font-rubik grey--text text--darken-1">
                                    Páginas {{ selectedBlockData.pageStart }} a {{ selectedBlockData.pageEnd }}
                                </p>
                                <p
                                    v-else-if="selectedBlockData.pageStart && selectedBlockData.pageEnd && selectedBlockData.pageStart === selectedBlockData.pageEnd">
                                    Página {{ selectedBlockData.pageStart }}
                                </p>
                            </div>


                            <pdf-viewer-block v-if="documentDetails && documentDetails.pdfUrl" ref="pdfSectionViewer"
                                :key="selectedBlockData.id" :pdf-url="documentDetails.pdfUrl"
                                :is-pdf-loading.sync="isPdfLoading" :document-id="documentId"
                                :block-id="selectedBlockData.id" :block-unique-id="selectedBlockData.uniqueId"
                                :block-name="selectedBlockData.name" :page-start="selectedBlockData.pageStart"
                                :page-end="selectedBlockData.pageEnd"
                                style="border-top: 1px solid #E3E5EB; margin: 0 auto;"
                                :nav-width="isNavVisible ? navDrawerWidth : 0"
                                @section-completed="handleSectionCompleted"
                                @request-navigation-next="navigateToNextBlock"
                                @request-navigation-previous="navigateToPreviousBlock" />


                            <div v-if="!isPdfLoading" class="d-flex mb-12 px-10"
                                style="justify-content: space-between; position: fixed; bottom: 40px !important"
                                :style="`width: calc(100vw - ${$vuetify.breakpoint.xs ? 40 : (isNavVisible ? (navDrawerWidth + 10) : 40)}px);`"
                                >
                                <v-btn color="primary" outlined @click="navigateToPreviousBlock"
                                    class="regular-btn font-rubik">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="mr-2 lucide lucide-arrow-left">
                                        <path d="m12 19-7-7 7-7" />
                                        <path d="M19 12H5" />
                                    </svg>
                                    Anterior
                                </v-btn>
                                <v-btn color="primary" @click="navigateToNextBlock"
                                    class="regular-btn-primary font-rubik">
                                    Ir al quiz
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="ml-2 lucide lucide-arrow-right-icon lucide-arrow-right">
                                        <path d="M5 12h14" />
                                        <path d="m12 5 7 7-7 7" />
                                    </svg>
                                </v-btn>
                            </div>


                            <!-- Input Area -->
                            <div v-if="showInputChat && (activeTab == 0 || !isNavVisible)"
                                class="input-area d-flex align-center px-2 py-1 white rounded-lg shadow"
                                style="height: 50px !important; position: fixed; bottom: 16px; z-index: 103; box-shadow: 0 3px 0 #dadada !important; border: 1px solid #e9e9e9 !important;"
                                :style="`width: calc(100vw - ${$vuetify.breakpoint.xs ? 40 : (isNavVisible ? (navDrawerWidth + 150) : 40)}px); max-width: 600px !important; left: ${isNavVisible ? `calc((100vw - ${navDrawerWidth}px) / 2)` : '50%'}; transform: translateX(-50%);`">
                                <div class="d-flex" style="position: relative; width: 100%;">
                                    <v-textarea v-model="chatInput" placeholder="Pregunta lo que quieras..." rows="1"
                                        :max-rows="$vuetify.breakpoint.xs ? 1 : 4" :auto-grow="!$vuetify.breakpoint.xs"
                                        dense hide-details outlined class=" elevation-0" solo flat
                                        @keydown.enter.prevent="handleEnterKey" :disabled="isAiResponding"
                                        ref="chatTextarea" style="flex: 1; max-height: 100%;"></v-textarea>
                                    <v-btn icon color="primary"
                                        :class="{ 'pulse-animation': chatInput.trim().length > 0 }"
                                        @click="sendChatMessage" :disabled="!chatInput.trim() || isAiResponding"
                                        class="send-button">
                                        <v-icon color="white">mdi-arrow-up</v-icon>
                                    </v-btn>
                                </div>
                            </div>


                            <!-- Blur effect -->
                            <div v-if="showInputChat && (activeTab == 0 || !isNavVisible)" class="blur-effect"></div>



                        </div>
                        <div v-else-if="selectedSubItemType === 'flashcards'">
                            <flashcards-view-block v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
                                :document-id="documentId" :block-id="selectedBlockData.id"
                                :block-unique-id="selectedBlockData.uniqueId" :block-name="selectedBlockData.name"
                                :view-mode="flashcardsViewMode"
                                @mark-item-as-completed="() => markItemAsCompleted(selectedBlockData.uniqueId, 'flashcards')"
                                @navigate-to-next-block="navigateToNextBlock"
                                :nav-width="isNavVisible ? navDrawerWidth : 0"
                                :key="`flashcards-${selectedBlockData.uniqueId}`" />
                            <flashcards-view-mobile v-else :document-id="documentId" :block-id="selectedBlockData.id"
                                :block-unique-id="selectedBlockData.uniqueId" :block-name="selectedBlockData.name"
                                :view-mode="flashcardsViewMode"
                                @mark-item-as-completed="() => markItemAsCompleted(selectedBlockData.uniqueId, 'flashcards')"
                                @navigate-to-next-block="navigateToNextBlock" style="width: 100%;" />
                        </div>
                        <div v-else-if="selectedSubItemType === 'quiz'">
                            <block-quiz-runner :document-id="documentId" :block-id="selectedBlockData.id"
                                :block-unique-id="selectedBlockData.uniqueId" :block-name="selectedBlockData.name"
                                :nav-width="isNavVisible ? navDrawerWidth : 0"
                                @section-completed="handleSectionCompleted"
                                @request-navigation-next="navigateToNextBlock"
                                @request-navigation-previous="navigateToPreviousBlock" style="width: 100%;" />
                        </div>
                        <div v-else class="pa-6 text-center grey--text">
                            Selecciona un elemento del índice para verlo aquí.
                        </div>
                    </div>

                </div>
                <div v-else class="text-center my-10 grey--text">
                    <v-icon large class="mb-4" color="grey lighten-1">mdi-comment-text-outline</v-icon>
                    <p>Selecciona un elemento del índice de la derecha para empezar.</p>
                </div>

            </div>



        <!-- Barra de navegación inferior tipo Instagram -->
        <div v-if="false && (selectedSubItemType === 'pdf' || selectedSubItemType === 'pdf-section')" 
             class="bottom-navigation-bar" 
             :class="{ 'bottom-nav-mobile': $vuetify.breakpoint.xs }">
            <div class="bottom-nav-container">
                <div class="bottom-nav-item" 
                     :class="{ 'nav-item-active': bottomNavSelected === 'home' }"
                     @click="selectBottomNavItem('home')">
                    <v-icon :color="bottomNavSelected === 'home' ? 'primary' : 'grey darken-1'" size="24">
                        mdi-file-pdf-box
                    </v-icon>
                    <span class="nav-item-label">PDF</span>
                </div>
                
                <div class="bottom-nav-item" 
                     :class="{ 'nav-item-active': bottomNavSelected === 'explanation' }"
                     @click="selectBottomNavItem('explanation')">
                    <v-icon :color="bottomNavSelected === 'explanation' ? 'primary' : 'grey darken-1'" size="24">
                        mdi-account-voice
                    </v-icon>
                    <span class="nav-item-label">Explicación</span>
                </div>
                
                <div class="bottom-nav-item" 
                     :class="{ 'nav-item-active': bottomNavSelected === 'quiz' }"
                     @click="selectBottomNavItem('quiz')">
                    <v-icon :color="bottomNavSelected === 'quiz' ? 'primary' : 'grey darken-1'" size="24">
                        mdi-help-circle-outline
                    </v-icon>
                    <span class="nav-item-label">Quiz</span>
                </div>
                
                <div class="bottom-nav-item" 
                     :class="{ 'nav-item-active': bottomNavSelected === 'flashcards' }"
                     @click="selectBottomNavItem('flashcards')">
                    <v-icon :color="bottomNavSelected === 'flashcards' ? 'primary' : 'grey darken-1'" size="24">
                        mdi-cards-outline
                    </v-icon>
                    <span class="nav-item-label">Tarjetas</span>
                </div>
            </div>
        </div>

        <!-- Dialog para selección de modo de práctica -->
        <v-dialog v-model="showPracticeModeDialog" max-width="500px">
            <v-card class="pa-6">
                <div class="text-center mb-4">
                    <v-icon size="48" :color="selectedPracticeType === 'explanation' ? 'orange' : 'primary'" class="mb-3">
                        {{ getPracticeTypeIcon(selectedPracticeType) }}
                    </v-icon>
                    <h2 class="font-weight-bold mb-2 font-rubik">
                        {{ getPracticeTypeTitle(selectedPracticeType) }}
                    </h2>
                    <p class="grey--text">¿Cómo quieres practicar?</p>
                </div>

                <div class="practice-mode-options mb-4">
                    <v-card class="practice-option-card mb-3" outlined @click="selectPracticeMode('all')"
                            :class="{ 'option-selected': selectedPracticeMode === 'all' }">
                        <v-card-text class="pa-4">
                            <div class="d-flex align-center">
                                <v-icon color="primary" size="32" class="mr-4">mdi-format-list-bulleted</v-icon>
                                <div class="flex-grow-1">
                                    <h3 class="font-weight-bold mb-1">Todos los temas</h3>
                                    <p class="mb-0 grey--text text--darken-1" style="font-size: 0.9rem;">
                                        Practica con todo el contenido disponible del documento
                                    </p>
                                </div>
                                <v-icon v-if="selectedPracticeMode === 'all'" color="primary">mdi-check-circle</v-icon>
                            </div>
                        </v-card-text>
                    </v-card>

                    <v-card class="practice-option-card" outlined @click="selectPracticeMode('specific')"
                            :class="{ 'option-selected': selectedPracticeMode === 'specific' }">
                        <v-card-text class="pa-4">
                            <div class="d-flex align-center">
                                <v-icon color="primary" size="32" class="mr-4">mdi-format-list-numbered</v-icon>
                                <div class="flex-grow-1">
                                    <h3 class="font-weight-bold mb-1">Tema específico</h3>
                                    <p class="mb-0 grey--text text--darken-1" style="font-size: 0.9rem;">
                                        Selecciona un tema particular para practicar
                                    </p>
                                </div>
                                <v-icon v-if="selectedPracticeMode === 'specific'" color="primary">mdi-check-circle</v-icon>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>

                <!-- Selector de tema específico -->
                <div v-if="selectedPracticeMode === 'specific'" class="specific-topic-selector mb-4">
                    <h4 class="font-weight-bold mb-3 font-rubik">Selecciona un tema:</h4>
                    <v-select v-model="selectedSpecificBlock" 
                              :items="availableBlocks" 
                              item-text="name" 
                              item-value="uniqueId"
                              label="Tema del documento"
                              outlined
                              dense
                              :disabled="!availableBlocks.length">
                        <template v-slot:item="{ item }">
                            <div class="d-flex align-center">
                                <span>{{ getBlockContentIndex(item.uniqueId) + 1 }}. {{ item.name }}</span>
                                <v-spacer></v-spacer>
                                <v-chip v-if="!item.isAccessible && !isPremium" 
                                        x-small color="warning" class="ml-2">Premium</v-chip>
                            </div>
                        </template>
                    </v-select>
                </div>

                <v-card-actions class="pa-0">
                    <v-btn text @click="closePracticeModeDialog">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" 
                           class="regular-btn-primary font-rubik"
                           :disabled="selectedPracticeMode === 'specific' && !selectedSpecificBlock"
                           @click="startPracticeSession">
                        <v-icon left>mdi-play</v-icon>
                        Empezar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-main>
 
        <!-- Botones de navegación fixed -->
        <div v-if="false" class="fixed-navigation-buttons" :class="{ 'fixed-nav-hidden': !showFixedNavButtons }">
            <v-btn color="primary" outlined :disabled="!canNavigateToPreviousBlock()" @click="navigateToPreviousBlock"
                class="regular-btn font-rubik" style="padding-left: 10px !important;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="mr-2 lucide lucide-arrow-left">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
                Anterior
            </v-btn>
            <v-btn color="primary" @click="navigateToNextBlock" class="regular-btn-primary font-rubik">
                Siguiente
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="ml-2 lucide lucide-arrow-right-icon lucide-arrow-right">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </v-btn>
        </div>

        <!-- Botón para mostrar/ocultar el panel de navegación -->
        <v-btn v-if="!isNavVisible || !$vuetify.breakpoint.xs" fab small color="transparent" class="toggle-nav-btn"
            @click="toggleNavDrawer" style="right: 10px !important;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-menu-icon lucide-menu">
                <path d="M4 12h16" />
                <path d="M4 18h16" />
                <path d="M4 6h16" />
            </svg>
        </v-btn>

        <!-- Calaix de Navegació (Índice y Asistente IA) -->
        <v-navigation-drawer :app="!$vuetify.breakpoint.xs" right clipped :width="navDrawerWidth"
            class="document-nav-drawer" :temporary="!isNavVisible" :value="isNavVisible" :permanent="isNavVisible"
            style="background-color: white; display: flex; flex-direction: column; z-index: 150;" :transition="false">
            <div class="drawer-resize-handle" @mousedown="startResize"></div>

            <v-tabs v-model="activeTab" class="custom-tabs elevation-0 flex-shrink-0" background-color="transparent">
                <v-tooltip bottom color="grey darken-4">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="$vuetify.breakpoint.xs" icon v-bind="attrs" v-on="on" small color="grey"
                            @click="toggleNavDrawer" style="position: absolute; top: 10px; right: 10px;">
                            <v-icon color="grey" small>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span class="text-caption font-rubik medium">Cerrar panel</span>
                </v-tooltip>

                <v-tab class="custom-tab font-none" :class="{ 'active-tab': activeTab === 0 }">
                    <lucide-zap :size="16" class="mr-2" />
                    <span class="tab-text font-none font-rubik">Estudio inteligente</span>
                </v-tab>
                <v-tab class="custom-tab font-none" :class="{ 'active-tab': activeTab === 1 }">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide mr-2 lucide-brain-icon lucide-brain">
                        <path
                            d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
                        <path
                            d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
                        <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
                        <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
                        <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
                        <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
                        <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
                        <path d="M6 18a4 4 0 0 1-1.967-.516" />
                        <path d="M19.967 17.484A4 4 0 0 1 18 18" />
                    </svg> -->

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-2 lucide lucide-bot-message-square-icon lucide-bot-message-square">
                        <path d="M12 6V2H8" />
                        <path d="m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z" />
                        <path d="M2 12h2" />
                        <path d="M9 11v2" />
                        <path d="M15 11v2" />
                        <path d="M20 12h2" />
                    </svg>
                    <span class="tab-text font-none font-rubik">Chat</span>
                </v-tab>
                <v-tabs-slider class="primary-slider"></v-tabs-slider>
            </v-tabs>

            <v-divider></v-divider>

            <v-tabs-items v-model="activeTab" class="flex-grow-1 custom-tabs-items"
                style="background-color: transparent;">
                <v-tab-item class="fill-height">
                    <!-- Contenido del Curso (antes era el único contenido del drawer) -->
                    <div class="nav-blocks-container shadow-md fill-height" ref="navBlocksContainer">



                        <!-- Mensaje de límite excedido en la barra lateral -->
                        <div v-if="showLimitExceededAlert" class="limit-exceeded-sidebar pa-4 mb-2">
                            <div class="d-flex flex-column">
                                <h3 class="mb-1 font-weight-bold">Límite de generación alcanzado</h3>

                                <p v-if="limitExceededReason === 'premium_limit_exceeded'" class="mb-2">
                                    Has alcanzado el límite mensual de 50 documentos para usuarios premium.
                                </p>
                                <p v-else class="mb-2">
                                    Has alcanzado el límite mensual de documentos para usuarios gratuitos.
                                </p>

                                <div v-if="limitExceededReason !== 'premium_limit_exceeded'"
                                    class="premium-benefits mb-3">
                                    <div class="d-flex align-start mb-1">
                                        <v-icon color="amber darken-2" small class="mr-1 mt-1">mdi-check-circle</v-icon>
                                        <span class="benefit-text">Genera materiales de estudio ilimitados</span>
                                    </div>
                                    <div class="d-flex align-start mb-1">
                                        <v-icon color="amber darken-2" small class="mr-1 mt-1">mdi-check-circle</v-icon>
                                        <span class="benefit-text">Acceso a todas las secciones</span>
                                    </div>
                                    <div class="d-flex align-start">
                                        <v-icon color="amber darken-2" small class="mr-1 mt-1">mdi-check-circle</v-icon>
                                        <span class="benefit-text">Asistente IA con respuestas avanzadas</span>
                                    </div>
                                </div>

                                <v-btn v-if="limitExceededReason !== 'premium_limit_exceeded'" color="primary"
                                    class="regular-btn-primary font-rubik" @click="showFeaturesDialog = true">
                                    <lucide-zap :size="16" class="mr-2" /> Hazte Premium
                                </v-btn>
                                <p v-else class="text-caption mt-2 grey--text text--darken-1">
                                    El límite se renovará al inicio del próximo mes. Contacta con soporte si necesitas
                                    generar más documentos.
                                </p>
                            </div>
                        </div>


                        <v-card v-else v-for="(block, index) in blocks" :key="block.uniqueId" :ripple="false"
                            class="nav-block-card rounded-0"
                            :class="{ 'nav-block-card-active': expandedBlocks.includes(block.uniqueId), 'nav-block-disabled': showLimitExceededAlert && !block.isPdfViewerEntry }"
                            flat @click="toggleBlock(block.uniqueId)" :ref="`block-${block.uniqueId}`">
                            <div class="py-3 px-4 d-flex flex-column align-start block-section-item"
                                :class="{ 'nav-block-card-active-header': selectedBlockUniqueId === block.uniqueId && !block.isPdfViewerEntry }">
                                <div class="d-flex align-center" style="width: 100%;">
                                    <span class="font-weight-medium font-weight-bold font-rubik"
                                        style="font-size: 1rem; flex: 1;">
                                        <template v-if="block.isPdfViewerEntry" class="d-flex align-center">
                                            <div class="d-flex align-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="mr-2 lucide lucide-file-icon lucide-file">
                                                    <path
                                                        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                                </svg>

                                                <!-- <v-icon left small class="mr-2">mdi-file-pdf-box</v-icon> -->
                                                <!-- {{ block.name }} -->
                                                Ver documento completo
                                            </div>
                                        </template>
                                        <template v-else>
                                            Sección {{ getBlockContentIndex(block.uniqueId) + 1 }}: {{ block.name }}
                                            <v-chip v-if="showLimitExceededAlert" x-small color="warning"
                                                class="ml-2">Límite</v-chip>
                                        </template>
                                    </span>

                                    <div v-if="!block.isPdfViewerEntry && block.subItems.length > 0">
                                        <v-tooltip v-if="block.subItems.every(item => !item.generated)" bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-progress-circular v-bind="attrs" v-on="on" class="mt-1" :size="16"
                                                    :width="2" indeterminate color="primary"></v-progress-circular>
                                            </template>
                                            <span>Generando materiales de estudio...</span>
                                        </v-tooltip>

                                        <v-icon v-else class="mt-1">{{
                                            expandedBlocks.includes(block.uniqueId) ? 'mdi-chevron-up' :
                                                'mdi-chevron-down' }}</v-icon>

                                    </div>
                                </div>
                                <div v-if="!block.isPdfViewerEntry" class="grey--text text--darken-2 mt-1"
                                    style="line-height: 1.2; font-size: 0.7rem;">
                                    {{ getBlockProgress(block) }}
                                </div>

                                <div v-if="!block.isPdfViewerEntry" style="width: 100%; height: 20px;">
                                    <v-progress-linear :value="getBlockProgressPercentage(block)" color="primary"
                                        height="8" background-color="#e2e2e2"
                                        class="mt-2 rounded-lg"></v-progress-linear>
                                </div>

                            </div>

                            <v-expand-transition v-if="!block.isPdfViewerEntry">
                                <div v-if="expandedBlocks.includes(block.uniqueId)">
                                    <v-divider></v-divider>

                                    <!-- Aviso único de restricción por sección -->
                                    <div v-if="hasRestrictedItems(block) && !isPremium"
                                        class="section-restriction-notice">
                                        <div class="restricted-content text-center">
                                            <p class="mb-2 font-rubik" style="font-size: 0.85rem;">
                                                <template v-if="showLimitExceededAlert">
                                                    Has alcanzado el límite mensual de generaciones.
                                                </template>
                                                <template v-else>
                                                    Contenido exclusivo para usuarios Premium.
                                                </template>
                                            </p>
                                            <v-btn small color="primary" class="font-rubik regular-btn-primary"
                                                @click.stop="showFeaturesDialog = true">
                                                <lucide-zap :size="14" class="mr-1" /> Hazte Premium
                                            </v-btn>
                                        </div>
                                    </div>

                                    <div class="">
                                        <v-card v-for="item in block.subItems" :key="item.type" :ripple="false" flat
                                            class="nav-subitem rounded-0" :class="{
                                                'nav-subitem-active': selectedBlockUniqueId === block.uniqueId && selectedSubItemType === item.type,
                                                'nav-subitem-disabled': (!block.isAccessible && !isPremium) || showLimitExceededAlert,
                                                'subitem-restricted': !block.isAccessible || showLimitExceededAlert
                                            }"
                                            :disabled="((!item.generated && item.type !== 'pdf-section') || !block.isAccessible || showLimitExceededAlert)"
                                            :loading="!item.generated && item.type !== 'pdf-section'"
                                            @click.stop="block.isAccessible && !showLimitExceededAlert ? selectItem(block.uniqueId, item.type) : showFeaturesDialog = true"
                                            :ref="`item-${block.uniqueId}-${item.type}`">
                                            <div class="px-3 py-4 d-flex align-start">
                                                <div class="checkbox-container mt-1"
                                                    :class="{ 'checkbox-completed': item.completed }"
                                                    @click.stop="!showLimitExceededAlert && toggleItemCompletion(block.uniqueId, block.id, item.type)">
                                                    <v-icon small v-if="item.completed" color="white"
                                                        style="color: white !important">mdi-check</v-icon>
                                                </div>
                                                <span class="font-rubik px-2 flex-grow-1"
                                                    style="margin-top: 2px; font-size: 0.9rem;">{{ item.name
                                                    }} </span>
                                                <span v-if="item.estimatedTime" class="text-caption grey--text mr-2"
                                                    style="margin-top: 2px;">{{
                                                        formatEstimatedTime(item.estimatedTime) }}</span>
                                                <span v-else-if="item.type === 'pdf-section' && block.audioDuration"
                                                    class="text-caption grey--text mr-2" style="margin-top: 2px;">{{
                                                        formatEstimatedTime(Math.ceil(block.audioDuration / 60)) }}</span>
                                                <v-icon small class="mt-1"
                                                    :color="selectedBlockUniqueId === block.uniqueId && selectedSubItemType === item.type ? 'primary' : 'grey'">{{
                                                        item.icon }}</v-icon>
                                            </div>
                                        </v-card>


                                    </div>
                                </div>
                            </v-expand-transition>

                            <div v-if="selectedBlockUniqueId === 'global-pdf-viewer'"
                                :style="{ position: 'fixed', bottom: '0px', right: '0px', width: navDrawerWidth + 'px' }"
                                class="pa-3 white">

                                <v-btn v-if="canStartStudy" color="primary" @click="navigateToNextBlock" block
                                    class="regular-btn-primary font-rubik">
                                    Empezar estudio inteligente

                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="ml-2 lucide lucide-arrow-right-icon lucide-arrow-right">
                                        <path d="M5 12h14" />
                                        <path d="m12 5 7 7-7 7" />
                                    </svg>
                                </v-btn>

                                <v-card v-else-if="!showLimitExceededAlert" color="primary"
                                    class="regular-btn-primary font-rubik d-flex align-center" style="z-index: 130">

                                    <v-progress-circular indeterminate color="white" :size="20" :width="2"
                                        class="mr-6"></v-progress-circular>

                                    Generando estudio inteligente...

                                </v-card>
                            </div>
                            <!-- <div v-else
                                :style="{ position: 'fixed', bottom: '0px', right: '0px', width: navDrawerWidth + 'px' }"
                                class="pa-3 white">
                                <v-btn v-if="canStartStudy" color="primary" @click="selectPdfViewer" block
                                    class="regular-btn-primary font-rubik">

                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="mr-2 lucide lucide-file-icon lucide-file">
                                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                    </svg>


                                    Ver documento completo
                                </v-btn>
                            </div> -->
                        </v-card>




                        <div v-if="structureLoading && blocks.length <= 1" class="pa-3 px-5">
                            <span class="font-rubik text-caption grey--text">Cargando estructura del documento...</span>
                            <v-skeleton-loader v-for="n in 5" :key="`skel-${n}`" type="list-item-two-line"
                                class=""></v-skeleton-loader>
                        </div>

                    </div>
                    <!-- Fin Contenido del Curso -->
                </v-tab-item>
                <v-tab-item class="fill-height">
                    <!-- Contenido del Asistente IA -->
                    <AIChatAssistant ref="aiChatAssistant" :document-id="documentId" :axios-instance="axiosInstance"
                        :toast-instance="toastInstance" :current-user="currentUser"
                        @navigate-to-page="navigateToDocPage" />
                    <!-- Fin Contenido del Asistente IA -->
                </v-tab-item>
            </v-tabs-items>
        </v-navigation-drawer>

        <!-- Dialog de Estudio Inteligente Completado -->
        <v-dialog v-model="showGenerationCompleteDialog" max-width="500px" class="dialog-generation-complete"
            :scrollable="true" style="overflow-y: hidden;">
            <v-card class="pa-6 d-flex flex-column fill-height" style="max-height: 100%;">
                <div class="text-center mb-5">
                    <div class="mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                            stroke="#4dd453" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-brain">
                            <path
                                d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
                            <path
                                d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
                            <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
                            <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
                            <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
                            <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
                            <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
                            <path d="M6 18a4 4 0 0 1-1.967-.516" />
                            <path d="M19.967 17.484A4 4 0 0 1 18 18" />
                        </svg>
                    </div>
                    <h2 class="font-weight-bold mb-2 font-rubik">¡Plan de estudio listo!</h2>
                </div>

                <v-card-text class="pa-0 flex-grow-1" style="overflow-y: auto;">
                    <div class="mb-3 text-center">
                        <p class="font-weight-medium mb-1" style="font-size: 15px; color: #424242;">Estudio por temas.
                            Para cada
                            bloque:</p>
                    </div>

                    <div class="study-methods mb-4">
                        <v-row no-gutters>
                            <v-col cols="4" class="text-center pa-2">
                                <div class="method-card pa-3 rounded-lg position-relative"
                                    style="background-color: #f8f9ff; border: 2px solid #e3f2fd;">
                                    <div class="method-number"
                                        style="position: absolute; top: 8px; left: 8px; background: rgb(212 214 227); color: white; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;">
                                        1</div>
                                    <v-icon size="32" color="#4dd453" class="mb-2">mdi-account-voice</v-icon>
                                    <div class="font-weight-bold" style="font-size: 14px;">Audio</div>
                                    <div class="grey--text" style="font-size: 12px;">Explicación</div>
                                </div>
                            </v-col>

                            <v-col cols="4" class="text-center pa-2">
                                <div class="method-card pa-3 rounded-lg position-relative"
                                    style="background-color: #f8f9ff; border: 2px solid #e3f2fd;">
                                    <div class="method-number"
                                        style="position: absolute; top: 8px; left: 8px; background: rgb(212 214 227); color: white; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;">
                                        2</div>
                                    <v-icon size="32" color="#4dd453" class="mb-2">mdi-cards-outline</v-icon>
                                    <div class="font-weight-bold" style="font-size: 14px;">Flashcards</div>
                                    <div class="grey--text" style="font-size: 12px;">Memorización</div>
                                </div>
                            </v-col>
                            <v-col cols="4" class="text-center pa-2">
                                <div class="method-card pa-3 rounded-lg position-relative"
                                    style="background-color: #f8f9ff; border: 2px solid #e3f2fd;">
                                    <div class="method-number"
                                        style="position: absolute; top: 8px; left: 8px; background: rgb(212 214 227); color: white; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;">
                                        3</div>
                                    <v-icon size="32" color="#4dd453" class="mb-2">mdi-help-circle-outline</v-icon>
                                    <div class="font-weight-bold" style="font-size: 14px;">Tests</div>
                                    <div class="grey--text" style="font-size: 12px;">Evaluación</div>
                                </div>
                            </v-col>

                        </v-row>
                    </div>

                    <div class="benefits-summary pa-3 rounded-lg text-center mb-4" style="background-color: #f0f8f0;">
                        <div class="d-flex align-center justify-center mb-1">
                            <v-icon color="#4dd453" class="mr-2" size="20">mdi-trending-up</v-icon>
                            <span class="font-weight-medium">Aumenta retención hasta 80%</span>
                        </div>
                        <div class="grey--text" style="font-size: 13px;">Según estudios de neurociencia cognitiva</div>
                    </div>

                    <p class="text-center grey--text text--darken-1 mb-0" style="font-size: 14px;">
                        Accede desde la barra lateral o empieza ahora
                    </p>
                </v-card-text>

                <v-card-actions class="pa-0 mt-4">
                    <v-btn text @click="dismissGenerationDialog" class="mr-2">
                        Más tarde
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="regular-btn-primary font-rubik flex-grow-1"
                        @click="startIntelligentStudy">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="mr-2 lucide lucide-brain">
                            <path
                                d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
                            <path
                                d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
                            <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
                            <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
                            <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
                            <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
                            <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
                            <path d="M6 18a4 4 0 0 1-1.967-.516" />
                            <path d="M19.967 17.484A4 4 0 0 1 18 18" />
                        </svg>
                        Empezar estudio
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para funcionalidad premium -->
        <features-dialog :showDialog.sync="showFeaturesDialog" />

        <!-- Dialog para login -->
        <v-dialog v-model="showLoginDialog"
              content-class="rounded-xl"
              persistent
              max-width="450">
      <div style="position: relative">
        <login-card
        :dialog.sync="showLoginDialog"
        :subtitle="'Inicia sesión para continuar'"
        :redirect="$route.path"
        ></login-card>
      </div>
    </v-dialog>
    </div>
</template>
<script>
import SummaryViewBlock from './components/SummaryViewBlock.vue';
import FlashcardsViewBlock from '../study/FlashcardsView.vue';
import BlockQuizRunner from './components/BlockQuizRunner.vue';
import PdfViewerBlock from './components/PdfViewerBlock.vue';
import Presentation from '../../../assets/icons/Presentation.vue';
import Images from '../../../assets/icons/Images.vue';
import { ExternalLink, Expand, ChevronUp, ChevronDown, Download, Home, LayoutList, Sparkles, User, Zap, Brain } from 'lucide-vue';
import DocumentActionsMenu from '../components/DocumentActionsMenu.vue';
import { eventBus } from '../../../eventBus'; // Importar Event Bus
import AIChatAssistant from './components/AIChatAssistant.vue';
import FeaturesDialog from '../../../components/premium/FeaturesDialog.vue';
import FlashcardsViewMobile from '../study/FlashcardsViewMobile.vue';
import LoginCard from '../../profile/login/components/LoginCard.vue';

export default {
    name: 'DocumentView',
    components: {
        SummaryViewBlock,
        FlashcardsViewBlock,
        FlashcardsViewMobile,
        BlockQuizRunner,
        PdfViewerBlock,
        Presentation,
        Images,
        LucideExternalLink: ExternalLink,
        LucideExpand: Expand,
        LucideChevronUp: ChevronUp,
        LucideChevronDown: ChevronDown,
        LucideHome: Home,
        DocumentActionsMenu,
        LucideDownload: Download,
        LucideLayoutList: LayoutList,
        LucideSparkles: Sparkles,
        LucideUser: User,
        LucideZap: Zap,
        LucideBrain: Brain,
        AIChatAssistant,
        FeaturesDialog,
        LoginCard
    },
    data() {
        return {
            documentId: this.$route.params.documentId,
            documentDetails: {},
            isLoading: true,
            isPdfLoading: true,
            showInputChat: false,
            documentError: null,
            firstBlockGenerated: false,
            actionLoading: false,
            blocks: [{
                uniqueId: 'global-pdf-viewer',
                name: 'Ver documento',
                id: 'global-pdf',
                subItems: [],
                isPdfViewerEntry: true
            }],
            structureLoading: true,
            structureError: null,
            flashcardsViewMode: 'cards',
            deleteDialog: false,
            selectedDocument: {},
            shareDialog: false,
            shareEmail: '',
            sharedEmails: [],
            showRenameDialog: false,
            newDocumentName: '',
            selectedBlockUniqueId: "global-pdf-viewer",
            selectedSubItemType: "pdf",
            expandedBlocks: [],
            showFixedNavButtons: true,
            lastScrollTop: 0,
            scrollTimeout: null,
            activeTab: 0,
            contentTypes: [
                { type: 'pdf-section', name: 'Apuntes explicados', icon: 'mdi-file-pdf-box', completed: false, score: null, estimatedTime: null },
                { type: 'quiz', name: 'Cuestionario', icon: 'mdi-help-circle-outline', completed: false, score: null, estimatedTime: null },
                { type: 'flashcards', name: 'Flashcards', icon: 'mdi-cards-outline', completed: false, score: null, estimatedTime: null }
            ],
            navDrawerWidth: 400,
            isNavVisible: true, // Nueva propiedad para controlar la visibilidad del panel
            resizing: false,
            isGeneratingDocumentContent: false, // Nueva propiedad para el estado de generación
            isStreamingStructure: false, // Nueva propiedad para el estado de streaming de estructura
            accumulatedJsonString: '',
            summaryContent: '', // Contenido del resumen cargado bajo demanda
            loadingSummary: false, // Estado de carga del resumen
            summaryError: null, // Error al cargar el resumen
            showGenerationCompleteDialog: false, // Dialog para cuando se completa la generación
            showFullDescription: false, // Nueva propiedad para mostrar/ocultar la descripción completa
            showFeaturesDialog: false, // Para mostrar el diálogo premium
            showLimitExceededAlert: false,
            limitExceededReason: null,
            limitExceededMessage: '',
            contentCache: {}, // Cache para almacenar contenido de bloques
            chatInput: '', // Input para el chat
            isAiResponding: false, // Estado para controlar si la IA está respondiendo
            teacherExplanationAudio: '',
            teacherExplanationContent: '',
            loadingTeacherExplanation: true,
            generatingBlockIds: [], // IDs de bloques en generación
            generationCheckInterval: null, // Intervalo para verificación de estado
            showLoginDialog: false,
            bottomNavSelected: 'home',
            selectedPracticeType: 'explanation',
            selectedPracticeMode: 'all',
            availableBlocks: [],
            selectedSpecificBlock: null,
            showPracticeModeDialog: false,
            isAllTopicsMode: false, // Nueva variable para rastrear si estamos en modo "todos los temas"
            currentPracticeType: null // Nueva variable para guardar el tipo de práctica actual en modo todos
        };
    },
    computed: {
        isPremium() {
            return this.$root.currentUser && this.$root.currentUser.premium === 1;
        },
        canStartStudy() {
            return !this.structureLoading && (this.blocks.length > 1 && this.blocks[1].subItems.every(item => item.generated))
        },
        selectedBlockData() {
            if (!this.selectedBlockUniqueId) {
                const pdfBlock = this.blocks.find(block => block.isPdfViewerEntry);
                return pdfBlock || null;
            }
            return this.blocks.find(block => block.uniqueId === this.selectedBlockUniqueId);
        },
        contentContainerClass() {
            if (this.selectedSubItemType === 'flashcards' || this.selectedSubItemType === 'quiz') {
                return 'd-flex flex-column align-center justify-center fill-height';
            }
            return '';
        },
        contentCardClass() {
            if (this.selectedSubItemType === 'flashcards' || this.selectedSubItemType === 'quiz') {
                return 'fill-height no-padding flex-grow-1 d-flex'; // Añade flex-grow-1 y d-flex
            }
            return '';
        },
        currentUser() { // Prop computada per passar l'usuari actual
            return this.$root.currentUser;
        },
        axiosInstance() { // Prop computada per passar axios
            return this.axios;
        },
        toastInstance() { // Prop computada per passar toast
            return this.$toast;
        },
        totalEstimatedStudyTime() {
            // Calcula el tiempo estimado total para todos los bloques y sus subítems
            let totalTime = 0;

            // Excluimos el bloque de PDF viewer
            const contentBlocks = this.blocks.filter(block => !block.isPdfViewerEntry);

            for (const block of contentBlocks) {
                if (block.subItems && Array.isArray(block.subItems)) {
                    // Sumar los tiempos estimados de cada subitem
                    for (const subItem of block.subItems) {
                        if (subItem.estimatedTime && !isNaN(subItem.estimatedTime)) {
                            totalTime += subItem.estimatedTime;
                        }
                    }
                }
            }

            return totalTime;
        },
        totalEstimatedStudyTimeFormatted() {
            return this.formatEstimatedTime(this.totalEstimatedStudyTime);
        }
    },
    mounted() {
        // Ensure the PDF viewer is the intended initial selection.
        // The actual rendering of selectedBlockData depends on `blocks` being populated.
        this.selectedBlockUniqueId = 'global-pdf-viewer';
        this.selectedSubItemType = 'pdf';

        this.fetchDocumentDetails(); // This will populate `blocks` and trigger relevant updates.

        // Cargar preferencia de visibilidad del panel
        const savedNavVisibility = localStorage.getItem('documentNavVisible');
        if (false && savedNavVisibility !== null) {
            this.isNavVisible = savedNavVisibility === 'true';
        } else {
            // Si no hay preferencia guardada, verificar si es un dispositivo móvil
            // y ocultar el panel de navegación automáticamente
            if (window.innerWidth < 960) {
                this.isNavVisible = false;
            }
        }

        // Agregar evento de scroll para controlar la visibilidad de los botones de navegación
        const contentArea = document.querySelector('.document-content-area');
        if (contentArea) {
            contentArea.addEventListener('scroll', this.handleScroll);
        }

        // Escuchar evento para mostrar PDF desde AppBar
        eventBus.$on('requestPdfView', this.handleRequestPdfView);

        // Eventos para resize del drawer
        window.addEventListener('mousemove', this.handleResize);
        window.addEventListener('mouseup', this.stopResize);

        // Agregar evento de resize para actualizar visibilidad en cambios de tamaño de ventana
        window.addEventListener('resize', this.handleWindowResize);
    },
    beforeDestroy() {
        // Limpiar el evento de scroll
        const contentArea = document.querySelector('.document-content-area');
        if (contentArea) {
            contentArea.removeEventListener('scroll', this.handleScroll);
        }
        // Dejar de escuchar el evento del PDF
        eventBus.$off('requestPdfView', this.handleRequestPdfView);

        // Remover eventos de resize
        window.removeEventListener('mousemove', this.handleResize);
        window.removeEventListener('mouseup', this.stopResize);
        window.removeEventListener('resize', this.handleWindowResize);

        // Detener el intervalo de verificación de bloques en generación
        this.stopGenerationCheckInterval();
    },
    watch: {
        activeTab(val) {
            if (!this.$vuetify.breakpoint.xs)
                if (val === 0) {
                    this.scrollToBlock(this.selectedBlockUniqueId);
                    this.navDrawerWidth = 400;
                } else {
                    this.navDrawerWidth = 500;
                    // this.navDrawerWidth = window.innerWidth * 0.5;

                    setTimeout(() => {

                        // Hacer focus en el textarea del chat cuando se seleccione la pestaña del chat
                        this.$nextTick(() => {
                            if (this.$refs.aiChatAssistant) {
                                this.$refs.aiChatAssistant.focusTextArea();
                            }
                        });
                    }, 300)
                }
        },
        blocks(newBlocks) {
            if (newBlocks && newBlocks.length > 0) {
                // Asegurar que el PDF viewer esté seleccionado por defecto si no hay selección
                if (!this.selectedBlockUniqueId || this.selectedBlockUniqueId !== 'global-pdf-viewer') {
                    this.selectPdfViewer();
                }

                // Expandir automáticamente el primer bloque de contenido si existe
                const firstContentBlock = newBlocks.find(b => !b.isPdfViewerEntry);
                if (firstContentBlock && !this.expandedBlocks.includes(firstContentBlock.uniqueId) && this.activeTab === 0) {
                    // this.expandedBlocks.push(firstContentBlock.uniqueId); // Comentado para evitar auto-expansión por ahora
                }
            }
            else if (this.selectedBlockUniqueId && newBlocks && !newBlocks.some(b => b.uniqueId === this.selectedBlockUniqueId)) {
                this.selectPdfViewer(); // Seleccionar PDF viewer si el bloque seleccionado ya no existe
            }
        },
        // Observar cambios en el bloque seleccionado para asegurar que esté expandido
        selectedBlockUniqueId(newBlockId) {
            const block = this.blocks.find(b => b.uniqueId === newBlockId);
            if (block && !block.isPdfViewerEntry && newBlockId && !this.expandedBlocks.includes(newBlockId)) {
                this.expandedBlocks.push(newBlockId);
                this.$nextTick(() => {
                    this.scrollToBlock(newBlockId);
                });
            }
        },
        canStartStudy(newVal) {
            if (newVal) {
                console.log("this.$root.currentUser", this.$root.currentUser)
                const isLoggedIn = this.$root.currentUser && this.$root.currentUser.userId;

                if (!isLoggedIn) {
                    console.log("isLoggedIn", isLoggedIn)
                    setTimeout(() => {
                        this.showLoginDialog = true;
                    }, 1000 * 60);
                } else {

                    // Verificar si ya se ha cerrado el diálogo para este documento
                    const cookieKey = `study_dialog_dismissed_${this.documentId}`;
                    const isDismissed = this.$cookies.get(cookieKey);

                    if (!isDismissed) {
                        this.showGenerationCompleteDialog = true;
                    }
                }
            }
        }
    },
    methods: {
        toggleNavDrawer() {
            this.isNavVisible = !this.isNavVisible;
            // Guardar preferencia en localStorage si es necesario
            localStorage.setItem('documentNavVisible', this.isNavVisible);


            setTimeout(() => {
                if (this.activeTab == 1)
                    // Hacer focus en el textarea del chat cuando se seleccione la pestaña del chat
                    this.$nextTick(() => {
                        if (this.$refs.aiChatAssistant) {
                            this.$refs.aiChatAssistant.focusTextArea();
                        }
                    });
            }, 300)
        },
        async streamDocumentStructure() {
            if (!this.documentId) {
                this.$toast.error("No hay ID de documento para obtener la estructura.");
                return;
            }
            this.isStreamingStructure = true;
            this.structureLoading = true;

            // Preservar el bloque del visor PDF en lugar de vaciar completamente
            const pdfViewerBlock = this.blocks.find(b => b.isPdfViewerEntry) || {
                uniqueId: 'global-pdf-viewer',
                name: 'Ver documento',
                id: 'global-pdf',
                subItems: [],
                isPdfViewerEntry: true
            };
            this.blocks = [pdfViewerBlock];

            let numberOffset = 0; // Para numerar los subitems correlativamente

            try {
                const backendUrl = process.env.VUE_APP_AXIOS_URI || '';
                const apiUrl = `${backendUrl}/generate-document-structure-stream`;

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'text/event-stream',
                        Authorization: this.$root.token?.value || ''
                    },
                    body: JSON.stringify({
                        documentId: this.documentId,
                        userId: this.$root.currentUser?.userId,
                        language: this.documentDetails?.language || 'auto'
                    })
                });

                if (!response.ok) {
                    // Verificar si es un error por límite excedido
                    if (response.status === 403) {
                        const errorData = await response.json();
                        if (errorData.reason === 'limit_exceeded' || errorData.reason === 'premium_limit_exceeded') {
                            this.showLimitExceededAlert = true;
                            this.limitExceededReason = errorData.reason;
                            this.limitExceededMessage = errorData.details;
                            this.structureError = errorData.details;

                            // Asegurarse de que el PDF viewer esté seleccionado
                            this.selectPdfViewer();

                            // Mostrar mensaje específico según si es usuario premium o no
                            const isPremiumLimit = errorData.reason === 'premium_limit_exceeded';
                            const limitMsg = isPremiumLimit
                                ? 'Límite de 50 documentos para usuarios premium alcanzado'
                                : 'Límite de 1 documento para usuarios gratuitos alcanzado';

                            this.$toast.warning(limitMsg);

                            // Terminar la función aquí, ya que no podemos generar estructura
                            this.structureLoading = false;
                            return;
                        }
                    }
                    throw new Error(`Error HTTP ${response.status}: ${response.statusText}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';

                while (true) {
                    const { done, value } = await reader.read();

                    if (done) {
                        console.log("Stream completado");
                        await this.fetchDocumentDetails(); // Re-fetch para obtener flags actualizados
                        break;
                    }

                    buffer += decoder.decode(value, { stream: true });
                    let eventBoundaryIndex;

                    while ((eventBoundaryIndex = buffer.indexOf('\n\n')) !== -1) {
                        const eventText = buffer.substring(0, eventBoundaryIndex);
                        buffer = buffer.substring(eventBoundaryIndex + 2);

                        let eventName = 'message';
                        let eventDataAccumulator = '';
                        const lines = eventText.split('\n');

                        lines.forEach(line => {
                            const trimmedLine = line.trim();
                            if (trimmedLine.startsWith('event:')) {
                                eventName = trimmedLine.substring(6).trim();
                            } else if (trimmedLine.startsWith('data:')) {
                                eventDataAccumulator += trimmedLine.substring(5).trim();
                            }
                        });

                        if (eventDataAccumulator) {
                            try {
                                console.log("[DEBUG] Recibido evento SSE:", eventName, "Datos:", eventDataAccumulator.substring(0, 100) + "...");
                                const parsedSSEData = JSON.parse(eventDataAccumulator);

                                // Procesar raw_chunk para actualizaciones incrementales
                                if (eventName === 'message' && parsedSSEData.type === 'raw_chunk' && parsedSSEData.text_chunk) {
                                    console.log("[DEBUG] Procesando raw_chunk:", parsedSSEData.text_chunk);
                                    // Acumular el texto del chunk
                                    this.accumulatedJsonString += parsedSSEData.text_chunk;
                                    console.log("[DEBUG] JSON acumulado:", this.accumulatedJsonString.substring(0, 100) + "...");

                                    try {
                                        let jsonToTry = this.accumulatedJsonString;
                                        let repairActions = [];

                                        // Comprobar si el string es un JSON válido antes de intentar repararlo
                                        try {
                                            JSON.parse(jsonToTry);
                                            console.log("[DEBUG] JSON ya es válido sin necesidad de reparaciones");
                                        } catch (e) {
                                            console.log("[DEBUG] JSON no es válido, iniciando reparaciones");

                                            // Heurística 1: Intentar arreglar strings no terminados
                                            // Contar comillas no escapadas. Si es impar, asumir un string no terminado.
                                            const quoteCount = (jsonToTry.match(/(?<!\\)\"/g) || []).length;
                                            if (quoteCount % 2 !== 0) {
                                                jsonToTry += "\"";
                                                repairActions.push("Añadida '\"': número impar de comillas");
                                            }

                                            // Heurística 2: Equilibrar corchetes
                                            let openBrackets = (jsonToTry.match(/\[/g) || []).length;
                                            let closeBrackets = (jsonToTry.match(/\]/g) || []).length;
                                            if (openBrackets > closeBrackets) {
                                                const missing = openBrackets - closeBrackets;
                                                jsonToTry += ']'.repeat(missing);
                                                repairActions.push(`Añadidos ${missing} ']'`);
                                            }

                                            // Heurística 3: Equilibrar llaves
                                            let openBraces = (jsonToTry.match(/{/g) || []).length;
                                            let closeBraces = (jsonToTry.match(/}/g) || []).length;
                                            if (openBraces > closeBraces) {
                                                const missing = openBraces - closeBraces;
                                                jsonToTry += '}'.repeat(missing);
                                                repairActions.push(`Añadidos ${missing} '}'`);
                                            }

                                            // Heurística 4: Si hay una coma al final y luego cerramos estructura
                                            jsonToTry = jsonToTry.replace(/,\s*(\]|\})$/g, '$1');

                                            // Heurística 5: Completar estructura básica si no existe
                                            if (!jsonToTry.includes('"document_structure"')) {
                                                // Si ni siquiera tiene la estructura básica, intentamos crearla
                                                if (jsonToTry.trim().startsWith('{')) {
                                                    // Ya empieza como objeto
                                                    if (!jsonToTry.includes('"document_name"')) {
                                                        jsonToTry = jsonToTry.replace('{', '{"document_name":"Documento"');
                                                        repairActions.push("Añadido document_name");
                                                    }

                                                    // Asegurarse de que hay una coma después de name si hay más propiedades
                                                    if (!jsonToTry.includes(',"document_description"') && !jsonToTry.includes('"document_description"')) {
                                                        jsonToTry = jsonToTry.replace(/"document_name"\s*:\s*"[^"]*"/, '$&,"document_description":"Descripción"');
                                                        repairActions.push("Añadido document_description");
                                                    }

                                                    // Asegurarse de que existe document_structure
                                                    if (!jsonToTry.includes('"document_structure"')) {
                                                        if (jsonToTry.endsWith('}')) {
                                                            jsonToTry = jsonToTry.replace(/}$/, ',"document_structure":[]}');
                                                        } else {
                                                            jsonToTry = jsonToTry + ',"document_structure":[]';
                                                            if (openBraces > closeBraces) {
                                                                jsonToTry += '}';
                                                            }
                                                        }
                                                        repairActions.push("Añadido document_structure vacío");
                                                    }
                                                } else {
                                                    // No empieza como objeto, lo envolvemos completamente
                                                    jsonToTry = '{"document_name":"Documento","document_description":"Descripción","document_structure":[]}';
                                                    repairActions.push("Creada estructura básica completa");
                                                }
                                            }

                                            // Heurística 6: Detección y reparación de estructuras document_structure incompletas
                                            const docStructMatch = jsonToTry.match(/"document_structure"\s*:\s*\[([^\]]*)$/);
                                            if (docStructMatch) {
                                                // document_structure está abierto y no cerrado
                                                const content = docStructMatch[1].trim();

                                                // Si termina con una coma o un objeto incompleto, cerramos
                                                if (content.endsWith(',')) {
                                                    jsonToTry = jsonToTry.substring(0, jsonToTry.lastIndexOf(',')) + ']';
                                                    if (openBraces > closeBraces) {
                                                        jsonToTry += '}';
                                                    }
                                                    repairActions.push("Cerrado document_structure que terminaba con coma");
                                                } else if (content.match(/{[^}]*$/)) {
                                                    // Hay un objeto abierto sin cerrar al final
                                                    jsonToTry += '}]';
                                                    if (openBraces > closeBraces + 1) { // +1 porque ya añadimos un }
                                                        jsonToTry += '}';
                                                    }
                                                    repairActions.push("Cerrado objeto incompleto en document_structure");
                                                }
                                            }

                                            // Heurística 7: Reparar secciones individuales incompletas
                                            jsonToTry = jsonToTry.replace(/"section_name"\s*:\s*"([^"]*)(?!")/, '"section_name":"$1"');
                                            jsonToTry = jsonToTry.replace(/"section_unique_id"\s*:\s*"([^"]*)(?!")/, '"section_unique_id":"$1"');
                                        }

                                        if (repairActions.length > 0) {
                                            console.log("[DEBUG] Acciones de reparación realizadas:", repairActions.join(", "));
                                        }

                                        // Solo intentar parsear si se ha hecho alguna reparación o si confiamos en que puede estar completo
                                        console.log("[DEBUG] Intentando parsear JSON reparado:", jsonToTry.substring(0, 200) + "...");

                                        try {
                                            const parsedJson = JSON.parse(jsonToTry); // Parsear el string reparado o el original

                                            console.log("[DEBUG] Parseo exitoso con reparaciones, estructura:",
                                                parsedJson.document_structure ?
                                                    `Tiene ${parsedJson.document_structure.length} secciones` :
                                                    "No tiene document_structure");

                                            // Si llegamos aquí, tenemos un JSON válido que podría tener la estructura
                                            if (parsedJson.document_structure && Array.isArray(parsedJson.document_structure)) {
                                                // Marcar section_unique_id para cualquier sección que no lo tenga
                                                parsedJson.document_structure.forEach((section, index) => {
                                                    if (!section.section_unique_id) {
                                                        section.section_unique_id = `auto-id-${index}-${Date.now()}`;
                                                    }
                                                });

                                                // Ya no filtramos por is_top_level
                                                const topLevelBlocks = parsedJson.document_structure; //.filter(block => block.is_top_level === true);
                                                console.log("[DEBUG] Secciones procesadas (desde chunk reparado):",
                                                    topLevelBlocks.length,
                                                    "Primera sección:",
                                                    topLevelBlocks.length > 0 ? topLevelBlocks[0].section_name : "ninguna");

                                                if (topLevelBlocks.length > 0) {
                                                    let numberOffset = 0;
                                                    const newBlocks = [
                                                        this.blocks[0] || {
                                                            uniqueId: 'global-pdf-viewer',
                                                            name: 'Ver documento',
                                                            id: 'global-pdf',
                                                            subItems: [],
                                                            isPdfViewerEntry: true
                                                        },
                                                        ...topLevelBlocks.map((block, index) => {
                                                            const subItems = this.contentTypes.map(type => {
                                                                numberOffset++;
                                                                return {
                                                                    ...type,
                                                                    // name: `${numberOffset}. ${type.name} de ${block.section_name}`,
                                                                    name: `${numberOffset}. ${type.name}`,
                                                                    completed: false,
                                                                    generated: !!block.generated, // Heredar el estado 'generated' del bloque padre
                                                                    estimatedTime: block.estimatedTimes || {}
                                                                };
                                                            });
                                                            return {
                                                                uniqueId: block.section_unique_id,
                                                                name: block.section_name,
                                                                id: block.id || null, // Usar block.id si existe
                                                                subItems,
                                                                isPdfViewerEntry: false,
                                                                estimatedTimes: block.estimatedTimes || {}
                                                            };
                                                        })
                                                    ];

                                                    const currentJSON = JSON.stringify(this.blocks);
                                                    const newJSON = JSON.stringify(newBlocks);
                                                    const hasChanges = currentJSON !== newJSON;
                                                    const hasMoreBlocks = newBlocks.length > this.blocks.length;

                                                    console.log("[DEBUG] Comparación de bloques (chunk reparado):", {
                                                        actuales: this.blocks.length,
                                                        nuevos: newBlocks.length,
                                                        hayDiferencias: hasChanges,
                                                        hayMasBloques: hasMoreBlocks
                                                    });

                                                    if (hasChanges || hasMoreBlocks) {
                                                        console.log("[DEBUG] Actualizando bloques desde chunk reparado:", newBlocks.length - 1);
                                                        // this.blocks = newBlocks;
                                                        this.blocks = newBlocks;
                                                    } else {
                                                        console.log("[DEBUG] No se actualizaron bloques (chunk reparado) porque no hay cambios significativos");
                                                    }
                                                }
                                            }
                                        } catch (finalParseError) {
                                            console.log("[DEBUG] Las reparaciones no fueron suficientes:", finalParseError.message);
                                            // Intentar una segunda reparación más agresiva si las primeras no funcionaron
                                            try {
                                                // Extraer solo la parte de document_structure si parece estar formada
                                                const structureMatch = this.accumulatedJsonString.match(/"document_structure"\s*:\s*\[([\s\S]*?)\](?=[,}]|$)/);
                                                if (structureMatch) {
                                                    const structureContent = structureMatch[1].trim();

                                                    // Intentar extraer secciones del JSON incompleto usando regex, 
                                                    // ya no filtramos por is_top_level
                                                    const sectionRegex = /{[^{]*?"section_name"\s*:\s*"([^"]+)"[^{]*?"section_unique_id"\s*:\s*"([^"]+)"[^}]*?}(?=[,\]]|$)/g;
                                                    const extractedSections = [];
                                                    let match;

                                                    while ((match = sectionRegex.exec(structureContent)) !== null) {
                                                        extractedSections.push({
                                                            section_name: match[1],
                                                            section_unique_id: match[2],
                                                        });
                                                    }

                                                    if (extractedSections.length > 0) {
                                                        console.log("[DEBUG] Extracción con regex recuperó", extractedSections.length, "secciones");

                                                        // Siempre crear bloques con las secciones encontradas, 
                                                        // aunque sean pocas, para mostrar progreso en tiempo real
                                                        // Crear bloques con las secciones extraídas
                                                        let numberOffset = 0;
                                                        const newBlocks = [
                                                            this.blocks[0] || {
                                                                uniqueId: 'global-pdf-viewer',
                                                                name: 'Ver documento',
                                                                id: 'global-pdf',
                                                                subItems: [],
                                                                isPdfViewerEntry: true
                                                            },
                                                            ...extractedSections.map((block, index) => {
                                                                const subItems = this.contentTypes.map(type => {
                                                                    numberOffset++;
                                                                    return {
                                                                        ...type,
                                                                        name: `${numberOffset}. ${type.name} de ${block.section_name}`,
                                                                        completed: false,
                                                                        generated: !!block.generated, // Heredar el estado 'generated' del bloque padre
                                                                        estimatedTime: null
                                                                    };
                                                                });
                                                                return {
                                                                    uniqueId: block.section_unique_id,
                                                                    name: block.section_name,
                                                                    id: null,
                                                                    subItems,
                                                                    isPdfViewerEntry: false,
                                                                    estimatedTimes: {}
                                                                };
                                                            })
                                                        ];

                                                        // Actualizar siempre que tengamos secciones, incluso si es 
                                                        // el mismo número que antes, para mostrar progreso en tiempo real
                                                        if (extractedSections.length > 0) {
                                                            console.log("[DEBUG] Actualizando bloques desde extracción regex:", newBlocks.length - 1);
                                                            this.blocks = newBlocks;
                                                        }
                                                    }
                                                } else {
                                                    // Intentar recuperar secciones individuales de forma aún más agresiva
                                                    // ya no filtramos por is_top_level
                                                    const sectionNameRegex = /"section_name"\s*:\s*"([^"]+)"/g;
                                                    const extractedNames = [];
                                                    let nameMatch;

                                                    while ((nameMatch = sectionNameRegex.exec(this.accumulatedJsonString)) !== null) {
                                                        extractedNames.push(nameMatch[1]);
                                                    }

                                                    if (extractedNames.length > 0 && extractedNames.length > (this.blocks.length - 1)) {
                                                        console.log("[DEBUG] Última esperanza: encontrados", extractedNames.length, "nombres de sección");

                                                        // Actualizar bloques incluso si solo hay uno o dos nombres extraídos
                                                        // para mostrar progreso en tiempo real
                                                        let numberOffset = 0;
                                                        const newBlocks = [
                                                            this.blocks[0] || {
                                                                uniqueId: 'global-pdf-viewer',
                                                                name: 'Ver documento',
                                                                id: 'global-pdf',
                                                                subItems: [],
                                                                isPdfViewerEntry: true
                                                            },
                                                            ...extractedNames.map((name, index) => {
                                                                const subItems = this.contentTypes.map(type => {
                                                                    numberOffset++;
                                                                    return {
                                                                        ...type,
                                                                        name: `${numberOffset}. ${type.name} de ${name}`,
                                                                        completed: false,
                                                                        generated: false, // No hay bloque padre definido en este contexto
                                                                        estimatedTime: null
                                                                    };
                                                                });
                                                                return {
                                                                    uniqueId: `extracted-${index}-${Date.now()}`,
                                                                    name: name,
                                                                    id: null,
                                                                    subItems,
                                                                    isPdfViewerEntry: false,
                                                                    estimatedTimes: {}
                                                                };
                                                            })
                                                        ];

                                                        if (extractedNames.length > 0) {
                                                            console.log("[DEBUG] Actualizando bloques desde nombres extraídos:", newBlocks.length - 1);
                                                            this.blocks = newBlocks;
                                                        }
                                                    }
                                                }
                                            } catch (finalRecoveryError) {
                                                console.log("[DEBUG] Todos los intentos de recuperación fallaron:", finalRecoveryError.message);
                                            }
                                        }
                                    } catch (parseError) {
                                        // No hacer nada si el parseo falla, simplemente seguir acumulando. 
                                        // El error se logueará con el JSON que se intentó parsear.
                                        const attemptedJsonForLog = (typeof jsonToTry !== 'undefined') ? jsonToTry.substring(0, 150) + "..." : "N/A (fallo antes de definir jsonToTry en el catch)";
                                        console.log("[DEBUG] Error al parsear JSON (incluso con reparaciones):", parseError.message, "JSON Original Acumulado:", this.accumulatedJsonString.substring(0, 100) + "...", "JSON Intentado con Reparaciones:", attemptedJsonForLog);
                                    }
                                }
                                // Procesar actualizaciones de estructura
                                else if (eventName === 'message' && parsedSSEData.type === 'structure_update' && parsedSSEData.data) {
                                    console.log("[DEBUG] Procesando structure_update completo");
                                    const structureData = parsedSSEData.data;

                                    // Procesar todos los bloques recibidos, sin filtrar por is_top_level
                                    const topLevelBlocks = structureData.document_structure;
                                    console.log("[DEBUG] Bloques procesados desde structure_update:", topLevelBlocks.length);

                                    let numberOffset = 0;
                                    // Actualizar los bloques manteniendo el PDF viewer
                                    const newBlocks = [
                                        this.blocks[0] || {
                                            uniqueId: 'global-pdf-viewer',
                                            name: 'Ver documento',
                                            id: 'global-pdf',
                                            subItems: [],
                                            isPdfViewerEntry: true
                                        }, // Mantener el PDF viewer o crearlo si no existe
                                        ...topLevelBlocks.map((block, index) => {
                                            const subItems = this.contentTypes.map(type => {
                                                numberOffset++;
                                                return {
                                                    ...type,
                                                    name: `${numberOffset}. ${type.name} de ${block.section_name}`,
                                                    completed: false,
                                                    generated: !!block.generated, // Heredar el estado 'generated' del bloque padre
                                                    estimatedTime: null
                                                };
                                            });

                                            return {
                                                uniqueId: block.section_unique_id,
                                                name: block.section_name,
                                                id: null,
                                                subItems,
                                                isPdfViewerEntry: false,
                                                estimatedTimes: {}
                                            };
                                        })
                                    ];

                                    // Actualizar los bloques solo si hay cambios
                                    if (JSON.stringify(this.blocks) !== JSON.stringify(newBlocks)) {
                                        console.log("[DEBUG] Actualizando bloques desde structure_update");
                                        // this.blocks = newBlocks;
                                        this.blocks = newBlocks;
                                        console.log(`Actualizados ${this.blocks.length - 1} bloques de contenido desde structure_update`);
                                    } else {
                                        console.log("[DEBUG] No hay cambios en los bloques desde structure_update");
                                    }
                                }
                                // Procesar evento final
                                else if (eventName === 'end' && parsedSSEData.final_structure) {
                                    console.log("[DEBUG] Procesando evento end");
                                    const structureData = parsedSSEData.final_structure;

                                    // Procesar todos los bloques recibidos, sin filtrar por is_top_level
                                    const topLevelBlocks = structureData.document_structure;
                                    console.log("[DEBUG] Bloques procesados finales:", topLevelBlocks.length);

                                    let numberOffset = 0;
                                    // Actualizar los bloques manteniendo el PDF viewer
                                    const newBlocks = [
                                        this.blocks[0] || {
                                            uniqueId: 'global-pdf-viewer',
                                            name: 'Ver documento',
                                            id: 'global-pdf',
                                            subItems: [],
                                            isPdfViewerEntry: true
                                        }, // Mantener el PDF viewer o crearlo si no existe
                                        ...topLevelBlocks.map((block, index) => {
                                            const subItems = this.contentTypes.map(type => {
                                                numberOffset++;
                                                return {
                                                    ...type,
                                                    name: `${numberOffset}. ${type.name} de ${block.section_name}`,
                                                    completed: false,
                                                    generated: !!block.generated, // Heredar el estado 'generated' del bloque padre
                                                    estimatedTime: null
                                                };
                                            });

                                            return {
                                                uniqueId: block.section_unique_id,
                                                name: block.section_name,
                                                id: null,
                                                subItems,
                                                isPdfViewerEntry: false,
                                                estimatedTimes: {}
                                            };
                                        })
                                    ];

                                    // Actualizar los bloques solo si hay cambios
                                    if (JSON.stringify(this.blocks) !== JSON.stringify(newBlocks)) {
                                        console.log("[DEBUG] Actualizando bloques finales");
                                        // this.blocks = newBlocks;
                                        this.blocks = newBlocks;
                                        console.log(`Actualizados ${this.blocks.length - 1} bloques de contenido desde end event`);
                                    } else {
                                        console.log("[DEBUG] No hay cambios en los bloques finales");
                                    }
                                }
                            } catch (error) {
                                console.log('[DEBUG] Error procesando evento:', error.message);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error en streamDocumentStructure:', error);

                // Verificar si es un error por límite excedido
                if (error.response && error.response.status === 403 && error.response.data &&
                    (error.response.data.reason === 'limit_exceeded' || error.response.data.reason === 'premium_limit_exceeded')) {
                    this.showLimitExceededAlert = true;
                    this.limitExceededReason = error.response.data.reason;
                    this.limitExceededMessage = error.response.data.details;
                    this.structureError = error.response.data.details;

                    // Asegurarse de que el PDF viewer esté seleccionado
                    this.selectPdfViewer();

                    // Mostrar mensaje específico según si es usuario premium o no
                    const isPremiumLimit = error.response.data.reason === 'premium_limit_exceeded';
                    this.$toast.warning(isPremiumLimit
                        ? 'Límite de 50 documentos para usuarios premium alcanzado'
                        : 'Límite de 1 documento para usuarios gratuitos alcanzado');
                } else {
                    this.$toast.error(`Error obteniendo estructura: ${error.message}`);
                    this.structureError = error.message;
                }

                await this.fetchDocumentDetails();
            } finally {
                this.isStreamingStructure = false;
                this.structureLoading = false;
            }
        },
        async initiateContentGeneration() {

            if (process.env.NODE_ENV === 'development') {
                return;
            }


            if (!this.documentId) {
                this.$toast.error("No hay ID de documento para generar contenido.");
                return;
            }

            await this.fetchStructureAndContent();

            let contentBlocks = this.blocks.filter(b => !b.isPdfViewerEntry && b.id && b.uniqueId);
            if (contentBlocks.length === 0) {
                this.$toast.info("No hay secciones de contenido estructurado para procesar.");
                if (this.documentDetails && !this.documentDetails.content_fully_generated) {
                    await this.markDocumentAsFullyGenerated();
                }
                return;
            }

            let allBlocksSucceededOverall = true;
            const generationPromises = [];

            console.log("[DEBUG] contentBlocks:", contentBlocks);

            // Separate the first block
            const firstBlock = contentBlocks.shift(); // Removes the first block and returns it

            // 1. Process the first block individually
            if (firstBlock) {
                const firstBlockAlreadyGenerated = firstBlock.generated || firstBlock.subItems.every(item => item.generated);
                const firstBlockIsGenerating = firstBlock.isGenerating;

                if (firstBlockAlreadyGenerated) {
                    console.log(`Contenido para el primer bloque "${firstBlock.name}" ya está generado, saltando.`);
                } else if (firstBlockIsGenerating) {
                    console.log(`El primer bloque "${firstBlock.name}" ya está en proceso de generación, saltando.`);
                } else {
                    console.log(`Preparando generación individual para el primer bloque: ${firstBlock.name} (ID: ${firstBlock.id}, UniqueID: ${firstBlock.uniqueId})`);

                    try {
                        const payload = {
                            documentId: this.documentId,
                            blockId: firstBlock.id,
                            blockUniqueId: firstBlock.uniqueId,
                            blockName: firstBlock.name,
                            pageStart: firstBlock.pageStart,
                            pageEnd: firstBlock.pageEnd,
                            contentTypes: ['fill_in_the_blank', 'flashcards', 'quiz'],
                            language: this.documentDetails?.language || 'auto',
                            userId: this.$root.currentUser.userId
                        };

                        // Marcar el bloque como en generación en la UI (antes de enviar la petición)
                        this.$set(firstBlock, 'isGenerating', true);

                        const response = await this.axios.post('/generate-block-content', payload, {
                            headers: { Authorization: this.$root.token.value }
                        });

                        if (response.data.success && response.data.content) {
                            // Añadir un retraso antes de actualizar la UI para asegurar que el streaming de red ha terminado
                            this.showGenerationCompleteDialog = true;

                            this.updateBlockUIAfterGeneration(firstBlock.uniqueId, response.data.content);

                            console.log(`Primer bloque "${firstBlock.name}" generado con éxito.`);

                            // Precargar los subitems del primer bloque
                            if (firstBlock.id) {
                                console.log("Precargando subitems del primer bloque...");

                                // Precargar flashcards (si existe un endpoint específico)
                                try {
                                    const flashcardsResponse = await this.axios.get(`/blocks/${firstBlock.id}/flashcards`, {
                                        headers: { Authorization: this.$root.token.value }
                                    });
                                    if (flashcardsResponse.data.success && flashcardsResponse.data.flashcards) {
                                        // Guardar en caché
                                        this.contentCache[`flashcards-${firstBlock.id}`] = flashcardsResponse.data.flashcards;
                                        console.log(`Flashcards para bloque ${firstBlock.id} guardadas en caché (${flashcardsResponse.data.flashcards.length || 0} tarjetas)`);
                                    }
                                } catch (err) {
                                    console.error(`Error precargando flashcards para bloque ${firstBlock.id}:`, err);
                                }

                                // Precargar quiz (si existe un endpoint específico)
                                try {
                                    const quizResponse = await this.axios.get(`/blocks/${firstBlock.id}/quiz`, {
                                        headers: { Authorization: this.$root.token.value }
                                    });
                                    if (quizResponse.data.success && quizResponse.data.quiz) {
                                        // Guardar en caché
                                        this.contentCache[`quiz-${firstBlock.id}`] = quizResponse.data.quiz;
                                        console.log(`Quiz para bloque ${firstBlock.id} guardado en caché (${quizResponse.data.quiz.questions?.length || 0} preguntas)`);
                                    }
                                } catch (err) {
                                    console.error(`Error precargando quiz para bloque ${firstBlock.id}:`, err);
                                }
                            }
                        } else {
                            // Desmarcar el bloque como en generación en caso de error
                            this.$set(firstBlock, 'isGenerating', false);

                            this.$toast.error(response.data.error || `Error generando contenido para "${firstBlock.name}".`);
                            console.error(`Error generating content for block ${firstBlock.name}:`, response.data.error, response.data.details);
                            allBlocksSucceededOverall = false;
                        }
                    } catch (error) {
                        // Desmarcar el bloque como en generación en caso de error
                        this.$set(firstBlock, 'isGenerating', false);

                        console.error(`Error crítico generando contenido para el bloque ${firstBlock.name}:`, error);
                        // this.$toast.error(`Error de red al generar contenido para "${firstBlock.name}".`);
                        allBlocksSucceededOverall = false;
                    }
                }
            }



            // 2. Process remaining blocks in chunks of three
            if (contentBlocks.length > 0) {
                let i = 0;
                const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

                // Función para procesar un bloque
                const processBlock = async (block) => {
                    try {
                        // Saltar bloques que ya tienen todos sus elementos generados
                        if (!!block.generated || block.subItems.every(item => !!item.generated)) {
                            console.log(`Bloque ${block.name} ya tiene todos sus elementos generados, saltando.`);
                            return { success: true, skipped: true, blockName: block.name };
                        }

                        // Saltar bloques que ya están en proceso de generación
                        if (block.isGenerating) {
                            console.log(`Bloque ${block.name} ya está en proceso de generación, saltando.`);
                            return { success: true, skipped: true, isGenerating: true, blockName: block.name };
                        }

                        if (false && !block.isAccessible) {
                            block.generated = true;
                            block.subItems.forEach(item => {
                                item.generated = true;
                            });
                            return { success: true, skipped: true, blockName: block.name };
                        }

                        // if (i >= 9 && !this.$root.currentUser.premium) {
                        //     block.isAccessible = false;
                        //     block.generated = true;
                        //     block.subItems.forEach(item => {
                        //         item.generated = true;
                        //     });
                        //     return { success: true, skipped: true, limitReached: true, blockName: block.name };
                        // }

                        console.log(`Preparando generación para el bloque: ${block.name} (ID: ${block.id}, UniqueID: ${block.uniqueId})`);

                        // Marcar el bloque como en generación en la UI antes de enviar la petición
                        this.$set(block, 'isGenerating', true);

                        const payload = {
                            documentId: this.documentId,
                            blockId: block.id,
                            blockUniqueId: block.uniqueId,
                            blockName: block.name,
                            pageStart: block.pageStart,
                            pageEnd: block.pageEnd,
                            contentTypes: ['fill_in_the_blank', 'flashcards', 'quiz'],
                            language: this.documentDetails?.language || 'auto',
                            userId: this.$root.currentUser.userId
                        };
                        const response = await this.axios.post('/generate-block-content', payload, {
                            headers: { Authorization: this.$root.token.value }
                        });

                        if (response.data.success && response.data.content) {
                            // Actualizar la UI para el bloque generado
                            this.updateBlockUIAfterGeneration(block.uniqueId, response.data.content);
                            return { success: true, blockName: block.name, blockUniqueId: block.uniqueId };
                        } else {
                            // Desmarcar el bloque como en generación en caso de error
                            this.$set(block, 'isGenerating', false);

                            // Manejar error en la generación del bloque
                            this.$toast.error(response.data.error || `Error generando contenido para "${block.name}".`);
                            console.error(`Error generating content for block ${block.name}:`, response.data.error, response.data.details);

                            // Si el error es por límite excedido, mostrar mensaje especial
                            if (response.data.limitExceeded) {
                                this.$toast.warning(`Has alcanzado el límite de bloques para usuarios gratuitos. Hazte Premium para generar más contenido.`);
                                this.showFeaturesDialog = true; // Mostrar diálogo premium
                            }

                            return { success: false, blockName: block.name, error: response.data.error };
                        }
                    } catch (error) {
                        // Desmarcar el bloque como en generación en caso de error
                        this.$set(block, 'isGenerating', false);

                        console.error(`Error crítico generando contenido para el bloque ${block.name}:`, error);
                        // this.$toast.error(`Error de red al generar contenido para "${block.name}".`);
                        return { success: false, blockName: block.name, error: error.message };
                    }
                };

                // Procesar bloques en grupos de 3
                const processBlocksInChunks = async () => {
                    const CHUNK_SIZE = 3;
                    const chunks = [];
                    for (let j = 0; j < contentBlocks.length; j += CHUNK_SIZE) {
                        chunks.push(contentBlocks.slice(j, j + CHUNK_SIZE));
                    }

                    // const chunks = [contentBlocks];

                    // Procesar cada chunk secuencialmente
                    for (const chunk of chunks) {
                        console.log(`Procesando grupo de ${chunk.length} bloques`);

                        // Procesar los bloques del chunk en paralelo
                        const chunkResults = await Promise.all(
                            chunk.map(async (block) => {
                                i++; // Incrementar contador global
                                if (true || block.isAccessible) {
                                    await sleep(100); // Pequeña pausa entre bloques del mismo chunk
                                }
                                return processBlock(block);
                            })
                        );

                        // Verificar si algún bloque falló
                        const anyFailed = chunkResults.some(result => !result.success);
                        if (anyFailed) {
                            console.warn("Al menos un bloque en el grupo falló en su generación");
                            allBlocksSucceededOverall = false;
                        }

                        // Mostrar límite excedido solo una vez si es necesario
                        const limitReached = chunkResults.some(result => result.limitReached);
                        if (limitReached && !this.$root.currentUser.premium) {
                            this.$toast.warning(`Has alcanzado el límite de diez bloques para usuarios gratuitos. Hazte Premium para generar más contenido.`);
                            this.showFeaturesDialog = true;
                        }

                        // Esperar un poco entre chunks para no sobrecargar el servidor
                        await sleep(1000);
                    }
                };

                // Ejecutar el procesamiento por chunks
                generationPromises.push(processBlocksInChunks());
            }

            if (generationPromises.length === 0) {
                // this.$toast.info("Todo el contenido ya estaba generado o no había bloques válidos para procesar.");
                this.isGeneratingDocumentContent = false;
                if (this.documentDetails && !this.documentDetails.content_fully_generated) {
                    await this.markDocumentAsFullyGenerated();
                }
                return;
            }

            console.log(`Ejecutando ${generationPromises.length} promesas de generación (individual + chunks)...`);
            await Promise.all(generationPromises);
            console.log("Todas las promesas de generación de contenido han finalizado.");

            if (generationPromises.length > 0) { // Only show final toast if something was attempted
                if (allBlocksSucceededOverall) {
                    // this.$toast.success("¡Todos los materiales de estudio han sido procesados exitosamente!");
                    await this.markDocumentAsFullyGenerated();

                } else {
                    this.$toast.warn("Algunos materiales no pudieron ser generados. Revisa la consola para más detalles o intenta de nuevo más tarde.");
                }
            } else if (!this.documentDetails.content_fully_generated) {
                // This case handles if generationPromises was empty because all content was already marked as generated by the UI
                // but the document itself wasn't marked as fully_generated in DB. 
                // The original toast "Todo el contenido ya estaba generado..." handles if UI also thought it was done.
                await this.markDocumentAsFullyGenerated();
            }

            this.isGeneratingDocumentContent = false;
        },
        updateBlockUIAfterGeneration(blockUniqueId, generatedContent) {
            const blockIndex = this.blocks.findIndex(b => b.uniqueId === blockUniqueId);
            if (blockIndex === -1) {
                console.warn(`Block with uniqueId ${blockUniqueId} not found for UI update.`);
                return;
            }

            const blockToUpdate = this.blocks[blockIndex];

            // Actualización más suave que solo modifica las propiedades específicas
            this.contentTypes.forEach(contentTypeObj => {
                const type = contentTypeObj.type;
                // Check if the backend response for this block includes this content type
                if (generatedContent[type]) {
                    const subItemIndex = blockToUpdate.subItems.findIndex(si => si.type === type);
                    if (subItemIndex !== -1) {
                        // Actualizar solo la propiedad 'generated', no todo el objeto
                        this.$set(blockToUpdate.subItems[subItemIndex], 'generated', true);
                    } else {
                        console.warn(`SubItem of type ${type} not found in block ${blockUniqueId} for UI update.`);
                    }
                }
            });

            // No reemplazamos el objeto completo, solo actualizamos banderas
            // para indicar que ha sido generado y ya no está en proceso de generación
            if (!blockToUpdate.generated) {
                this.$set(blockToUpdate, 'generated', true);
            }

            // Asegurarse de que la bandera isGenerating se establece a false
            if (blockToUpdate.isGenerating) {
                this.$set(blockToUpdate, 'isGenerating', false);
            }

            // Marcamos que estamos generando contenido, pero sin forzar re-renders innecesarios
            if (!this.isGeneratingDocumentContent) {
                this.isGeneratingDocumentContent = true;
            }
        },
        async markDocumentAsFullyGenerated() {
            if (this.documentDetails) {
                this.documentDetails.content_fully_generated = true;
            }
            try {
                console.log(`Attempting to mark document ${this.documentId} as fully generated.`);
                const response = await this.axios.post(`/documents/${this.documentId}/mark-content-generated`,
                    { userId: this.$root.currentUser.userId }, // Include userId in request body
                    { headers: { Authorization: this.$root.token.value } }
                );
                if (response.data.success) {
                    console.log("Documento marcado como completamente generado en el backend.");
                } else {
                    console.warn("Backend no pudo marcar el documento como completamente generado:", response.data.error);
                    // this.$toast.warn(response.data.error || "No se pudo actualizar el estado final del documento.");
                    if (this.documentDetails) {
                        this.documentDetails.content_fully_generated = false;
                    }
                }
            } catch (error) {
                console.error("Error marcando el documento como completamente generado:", error);
                // this.$toast.error("Error de red al finalizar el estado de generación del documento.");
                if (this.documentDetails) {
                    this.documentDetails.content_fully_generated = false;
                }
            }
        },
        handleRequestPdfView(data) {
            console.log("VIEW: Received requestPdfView event via EventBus", data);
            if (data && data.documentId === this.documentId) {
                this.selectPdfViewer();
                // this.activeTab = 0;
            }
        },
        async fetchDocumentDetails() {
            console.log("fetchDocumentDetails");
            this.isLoading = true;
            this.documentError = null;
            try {
                const response = await this.axios.get(`/documents/${this.documentId}`, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                });
                if (response.data.success) {
                    this.documentDetails = response.data.document;
                    this.selectedDocument = this.documentDetails;

                    let allBlocksGenerated = true;

                    console.log("this.blocks && this.blocks.length && this.blocks.some(b => !b.generated)", this.blocks && this.blocks.length && this.blocks.some(b => !b.generated))

                    if (this.blocks && this.blocks.length && this.blocks.some(b => !b.generated)) {
                        allBlocksGenerated = false
                    }

                    console.log("this.documentDetails && !this.documentDetails.structure_generated", this.documentDetails && !this.documentDetails.structure_generated)


                    if (this.documentDetails && !this.documentDetails.structure_generated) {
                        // this.$toast.info("Iniciando generación eficiente del estudio con inteligencia artificial...");
                        await this.streamDocumentStructure();
                        // streamDocumentStructure ahora llama a fetchDocumentDetails al final,
                        // por lo que el flujo continuará desde allí después del re-fetch.
                    } else if (this.documentDetails && (!this.documentDetails.content_fully_generated || !allBlocksGenerated)) {
                        // La estructura ya existe (o acaba de ser streameada y fetchDocumentDetails la actualizó)
                        // Si this.blocks está vacío, cargarla primero antes de generar contenido.
                        if (this.blocks.length <= 1) { // Solo PDF viewer o vacío
                            await this.fetchStructureAndContent(); // Carga la estructura desde DB a this.blocks
                        }
                        // this.$toast.info("Iniciando generación eficiente del estudio con inteligencia artificial...");

                        // todo; uncomment this when ready
                        this.initiateContentGeneration();
                    } else {
                        // Contenido y estructura ya generados
                        this.fetchStructureAndContent();
                    }

                } else {
                    this.documentError = response.data.error || 'No se pudo cargar la información del documento';
                }
            } catch (error) {
                console.error('Error al cargar los detalles del documento:', error);
                this.documentError = 'Error al cargar los detalles del documento';
            } finally {
                this.isLoading = false;

                setTimeout(() => {
                    this.$refs.pdfViewerBlock.calculateScrollThreshold();
                }, 300);
            }
        },
        async fetchStructureAndContent() {
            console.log("fetchStructureAndContent");
            // this.structureLoading = true;
            this.structureError = null;

            // Preservar el bloque del visor PDF en lugar de vaciar completamente
            const pdfViewerBlock = this.blocks.find(b => b.isPdfViewerEntry) || {
                uniqueId: 'global-pdf-viewer',
                name: 'Ver documento',
                id: 'global-pdf',
                subItems: [],
                isPdfViewerEntry: true
            };
            this.blocks = [pdfViewerBlock];


            try {
                // Obtener la estructura del documento
                const structureResponse = await this.axios.post(`/documents/${this.documentId}/structure`, {
                    userId: this.$root.currentUser.userId
                });

                if (structureResponse.data.success && structureResponse.data.structure) {
                    let completionResponse = null;
                    try {
                    // Obtener el estado de completado para cada bloque
                    completionResponse = await this.axios.get(`/documents/${this.documentId}/user-progress`, {
                        headers: { Authorization: this.$root.token.value }
                    });
                    } catch (error) {
                        console.error('📌 Error fetching user progress:', error);
                    }
                    const completionData = completionResponse && completionResponse.data && completionResponse.data.success ? completionResponse.data.progress : {};

                    // Obtener los tiempos estimados para cada bloque y tipo de contenido
                    // Ya no se necesita una llamada separada, los tiempos vienen con la estructura.
                    // const estimatedTimesResponse = await this.axios.get(`/documents/${this.documentId}/estimated-times`, {
                    //     headers: { Authorization: this.$root.token.value }
                    // });
                    // const estimatedTimesData = estimatedTimesResponse.data.success ? estimatedTimesResponse.data.times : {};

                    let number = 0;

                    // Procesar bloques de contenido
                    const contentBlocks = structureResponse.data.structure.map((block, index) => {
                        const uniqueId = block.uniqueId || `block-${block.id || index}-${Date.now()}`;
                        const blockCompletion = completionData[block.id] || {};
                        // Los tiempos estimados ahora vienen directamente en el objeto block como block.estimatedTimes
                        const blockEstimatedTimes = block.estimatedTimes || {};

                        // Crear subItems para cada bloque con los tipos de contenido definidos
                        const generatedSubItems = this.contentTypes.map(type => {
                            number++;
                            return {
                                ...type,
                                // name: `${number}. ${type.name} de ${block.name}`,
                                name: `${number}. ${type.name}`,
                                completed: !!blockCompletion[type.type], // Convertir a booleano
                                generated: !!block.generated, // Heredar el estado 'generated' del bloque padre
                                estimatedTime: blockEstimatedTimes[type.type] || null // Asignar tiempo estimado
                            };
                        });


                        return {
                            ...block,
                            uniqueId: uniqueId,
                            isGenerating: !!block.is_generating, // Añadir propiedad is_generating desde la estructura
                            subItems: generatedSubItems // Solo subitems generados
                        };
                    });

                    // Crear bloque especial para "Ver PDF Original"
                    const pdfViewerBlock = {
                        uniqueId: 'global-pdf-viewer',
                        name: 'Ver documento',
                        id: 'global-pdf', // ID especial
                        subItems: [], // Sin subitems
                        isPdfViewerEntry: true // Flag para identificarlo en la plantilla
                    };

                    // Combinar el bloque PDF al principio con los bloques de contenido
                    this.blocks = [pdfViewerBlock, ...contentBlocks];

                    // Si el contenido está completamente generado, marcar todos los subbloques como completados
                    if (this.documentDetails && this.documentDetails.content_fully_generated) {
                        // Solo actualizar si no se está cargando ya (para evitar múltiples actualizaciones)
                        if (!this.isGeneratingDocumentContent) {
                            let hasChanges = false;

                            // Recorrer todos los bloques para marcar como completados
                            for (const block of this.blocks) {
                                // Saltar el bloque del visor PDF
                                if (block.isPdfViewerEntry) continue;

                                // Recorrer todos los subitems de cada bloque
                                for (const subItem of block.subItems) {
                                    // Solo actualizar si no estaba ya completado
                                    console.log(subItem);
                                    if (!subItem.generated) {
                                        // Marcar como completado en la UI
                                        subItem.generated = true;

                                        // Actualizar en el servidor
                                        // this.updateUserProgress(block.id, subItem.type, true);

                                        hasChanges = true;
                                    }
                                }
                            }

                            // Emitir evento para actualizar la AppBar si hubo cambios
                            if (hasChanges) {
                                eventBus.$emit('documentProgressUpdated', { documentId: this.documentId, blocks: this.blocks });
                            }
                        }
                    }

                    // Si el bloque activo es global-pdf-viewer y hay al menos un bloque de contenido generado,
                    // expandir automáticamente la primera sección
                    this.$nextTick(() => {
                        if (this.selectedBlockUniqueId === 'global-pdf-viewer' &&
                            this.blocks.length > 1 &&
                            this.blocks[1] &&
                            this.blocks[1].generated) {
                            this.expandedBlocks.push(this.blocks[1].uniqueId);
                        }
                    });


                    // Iniciar seguimiento de bloques en generación
                    this.trackGeneratingBlocks();

                } else {
                    this.structureError = structureResponse.data.error || 'No se pudo cargar la estructura del documento.';
                    console.warn("API did not return structure successfully:", structureResponse.data);
                    this.blocks = [];
                }
            } catch (error) {
                console.error('Error fetching document structure:', error);
                this.structureError = 'Error al conectar con el servidor para obtener la estructura.';
                this.blocks = [];
            } finally {
                this.structureLoading = false;
                this.showInputChat = true;
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
            const dia = date.getDate();
            const mes = meses[date.getMonth()];
            const año = date.getFullYear();
            return `${dia} de ${mes} de ${año}`;
        },
        async downloadDocument() {
            if (!this.documentDetails.id) return;

            // Verificar si el usuario es premium
            if (!this.$root.currentUser || !this.$root.currentUser.premium) {
                this.showPremiumFeature = true;
                return;
            }

            this.actionLoading = true;
            try {
                const response = await this.axios.get(`/documents/${this.documentDetails.id}/download`, {
                    headers: { Authorization: this.$root.token.value },
                    responseType: 'blob'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.documentDetails.name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.$toast.success('Documento descargado correctamente');
            } catch (error) {
                console.error('Error al descargar el documento:', error);
                this.$toast.error('Error al descargar el documento');
            } finally {
                this.actionLoading = false;
            }
        },
        handleUpgrade() {
            this.showPremiumFeature = false;
            this.$router.push('/app/settings/subscription');
        },
        goBackToSubject() {
            if (this.documentDetails && this.documentDetails.subject_id) {
                this.$router.push({ path: '/app', query: { subject: this.documentDetails.subject_id } });
            } else {
                this.$router.push('/app');
            }
        },
        expandBlock(blockUniqueId) {
            //  if (this.selectedBlockUniqueId !== blockUniqueId) {
            //      this.selectItem(blockUniqueId, 'summary');
            //  }
        },
        selectItem(blockUniqueId, subItemType) {
            console.log(`Seleccionando bloque: ${blockUniqueId}, tipo: ${subItemType}`);

            // Si no se proporciona un tipo de subítem (o es null/undefined), 
            // mantener el tipo actual si hay alguno seleccionado
            if (!subItemType && this.selectedSubItemType) {
                subItemType = this.selectedSubItemType;
                console.log(`Manteniendo tipo existente: ${subItemType}`);
            }

            // Si aún no hay tipo, por defecto usar 'pdf'
            if (!subItemType) {
                subItemType = 'pdf';
                console.log(`Usando tipo por defecto: pdf-section para bloque de contenido`);
                subItemType = 'pdf-section'; // Por defecto ahora es pdf-section para bloques de contenido
            }
            
            // Verificar si estamos en modo "todos los temas" y el usuario selecciona algo diferente
            if (this.isAllTopicsMode && this.currentPracticeType && subItemType !== this.currentPracticeType) {
                console.log(`Desactivando modo "todos los temas" porque se seleccionó ${subItemType} en lugar de ${this.currentPracticeType}`);
                this.isAllTopicsMode = false;
                this.currentPracticeType = null;
                this.bottomNavSelected = 'home'; // Resetear también la barra de navegación
            }

            // Si estamos cambiando de un bloque a otro mientras se ve flashcards,
            // forzar la recarga del componente
            const forceFreshComponent = this.selectedSubItemType === 'flashcards' &&
                subItemType === 'flashcards' &&
                this.selectedBlockUniqueId !== blockUniqueId;

            // Actualizar las propiedades seleccionadas
            this.selectedBlockUniqueId = blockUniqueId;
            this.selectedSubItemType = subItemType;

            // Buscar el bloque seleccionado
            const block = this.blocks.find(b => b.uniqueId === blockUniqueId);

            // Si es un resumen, flashcards o quiz, comprobar caché
            if (block && block.id && ['pdf-section', 'flashcards', 'quiz', 'teacher-explanation'].includes(subItemType)) {
                const cacheKey = `${subItemType}-${block.id}`;

                // Si no está en caché, cargar el contenido
                if (!this.contentCache[cacheKey]) {
                    console.log(`Contenido no encontrado en caché para ${cacheKey}, cargando...`);

                    // Para el resumen, usar el método existente que ya fue modificado
                    if (subItemType === 'pdf-section') {
                        // No necesitamos cargar nada para pdf-section, el componente lo gestiona
                        console.log('Mostrando sección de PDF sin carga adicional de datos');
                    }
                    // Para la explicación del profesor, cargamos el contenido
                    else if (subItemType === 'teacher-explanation') {
                        this.loadTeacherExplanation(block.id);
                    }
                    // Para flashcards y quiz, podríamos implementar métodos similares en el futuro
                    // Por ahora, avisamos que no está en caché
                    else {
                        console.log(`Tipo de contenido ${subItemType} no implementado para caché automática`);
                    }
                } else {
                    console.log(`Usando contenido en caché para ${cacheKey}`);
                    // Si es explicación del profesor, actualizar directamente desde la caché
                    if (subItemType === 'teacher-explanation') {
                        this.teacherExplanationContent = this.contentCache[cacheKey].content;
                        this.teacherExplanationAudio = this.contentCache[cacheKey].audioUrl;
                        this.loadingTeacherExplanation = false;
                    }
                }
            }

            // Asegurarse de que el bloque esté expandido (si no es el PDF global)
            if (block && !block.isPdfViewerEntry && !this.expandedBlocks.includes(blockUniqueId)) {
                this.expandedBlocks.push(blockUniqueId);
            }

            // Si el tipo es 'pdf-section' o 'pdf', marcar como completado inmediatamente
            // if (subItemType === 'pdf-section' || subItemType === 'pdf') {
            //     // Solo marcar pdf-section como completado al seleccionar, el PDF global no se marca
            //     if (subItemType === 'pdf-section') {
            //         this.markItemAsCompleted(blockUniqueId, subItemType);
            //     }
            // }

            // Hacer autoscroll al elemento seleccionado
            this.$nextTick(() => {
                // Scroll del contenido principal al inicio
                const contentArea = this.$el.querySelector('.document-content-area .v-main__wrap');
                if (contentArea) {
                    contentArea.scrollTop = 0;
                }

                // Autoscroll del elemento seleccionado en la barra lateral
                this.scrollToSelectedItem();

                // Si cambiamos de un componente flashcards a otro, forzar su recarga
                if (forceFreshComponent) {
                    // Forzar recarga del componente primero ocultándolo
                    const tempType = this.selectedSubItemType;
                    this.selectedSubItemType = null;

                    // Luego, mostrar de nuevo en el siguiente ciclo
                    this.$nextTick(() => {
                        this.selectedSubItemType = tempType;
                    });
                }
            });

            window.scrollTo(0, 0);

            if (this.$vuetify.breakpoint.smAndDown) {
                this.isNavVisible = false;
            }
        },
        clearSelection() {
            this.selectedBlockUniqueId = null;
            this.selectedSubItemType = null;
            // No borramos los expandedBlocks para mantener el estado de expansión
        },
        showDeleteDialog(document) {
            this.selectedDocument = document || this.documentDetails;
            this.deleteDialog = true;
        },
        async deleteDocument() {
            if (!this.selectedDocument.id) return;
            try {
                const response = await this.axios.delete(`/documents/${this.selectedDocument.id}`, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success) {
                    console.log('Material eliminado con éxito');
                    this.$toast.success('Material eliminado');
                    this.goBackToSubject();
                } else {
                    console.error(response.data.error || 'No se pudo eliminar el material');
                    this.$toast.error(response.data.error || 'No se pudo eliminar el material');
                }
            } catch (err) {
                console.error('Error al eliminar el material:', err);
                this.$toast.error('Error al eliminar el material');
            } finally {
                this.deleteDialog = false;
            }
        },
        shareDocument(document) {
            this.selectedDocument = document || this.documentDetails;
            this.shareEmail = '';
            this.loadSharedEmails(this.selectedDocument.id);
            this.shareDialog = true;
        },
        async loadSharedEmails(documentId) {
            if (!documentId) return;
            try {
                const response = await this.axios.get(`/documents/${documentId}/shared-with`, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success) {
                    this.sharedEmails = response.data.sharedWith || [];
                } else {
                    this.sharedEmails = [];
                    console.error('Error al cargar los destinatarios compartidos:', response.data.error);
                }
            } catch (err) {
                this.sharedEmails = [];
                console.error('Error al cargar los destinatarios compartidos:', err);
            }
        },
        async sendShareEmail() {
            if (!this.shareEmail || !this.selectedDocument.id) return;
            try {
                const response = await this.axios.post('/documents/share', {
                    documentId: this.selectedDocument.id,
                    email: this.shareEmail
                }, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success) {
                    this.$toast.success(`Compartido con ${this.shareEmail}`);
                    this.shareEmail = '';
                    await this.loadSharedEmails(this.selectedDocument.id);
                } else {
                    this.$toast.error(response.data.error || 'No se pudo compartir');
                    console.error(response.data.error || 'No se pudo compartir el material');
                }
            } catch (err) {
                this.$toast.error('Error al compartir el material');
                console.error('Error al compartir el material:', err);
            }
        },
        renameDocument(document) {
            this.selectedDocument = document || this.documentDetails;
            this.newDocumentName = this.selectedDocument.name || '';
            this.showRenameDialog = true;
        },
        async saveNewName() {
            const newName = this.newDocumentName.trim();
            if (!newName || !this.selectedDocument.id) return;
            try {
                const response = await this.axios.put(`/documents/${this.selectedDocument.id}/rename`, {
                    name: newName
                }, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success) {
                    if (this.documentDetails.id === this.selectedDocument.id) {
                        this.documentDetails.name = response.data.newName;
                    }
                    this.selectedDocument.name = response.data.newName;
                    this.$toast.success('Documento renombrado');
                } else {
                    this.$toast.error(response.data.error || 'No se pudo renombrar');
                    console.error(response.data.error || 'No se pudo renombrar el documento');
                }
            } catch (err) {
                this.$toast.error('Error al renombrar el documento');
                console.error('Error al renombrar el documento:', err);
            } finally {
                this.showRenameDialog = false;
            }
        },
        async createCopy(document) {
            const docToCopy = document || this.documentDetails;
            if (!docToCopy.id) return;
            try {
                const response = await this.axios.post(`/documents/${docToCopy.id}/copy`, {}, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success && response.data.new_document) {
                    this.$toast.success(`Copia "${response.data.new_document.name}" creada`);
                } else {
                    this.$toast.error(response.data.error || 'No se pudo crear la copia');
                    console.error(response.data.error || 'No se pudo crear una copia');
                }
            } catch (err) {
                this.$toast.error('Error al crear copia');
                console.error('Error al crear copia:', err);
            }
        },
        getBlockIndex(blockUniqueId) {
            // Asegurarse de que blockUniqueId no sea null o undefined
            if (!blockUniqueId) return -1;

            // Encontrar el índice del bloque
            return this.blocks.findIndex(block => block.uniqueId === blockUniqueId);
        },
        getPreviousBlockId() {
            const contentBlocks = this.blocks.filter(b => !b.isPdfViewerEntry);
            if (!this.selectedBlockUniqueId || this.blocks.length === 0) return null;

            const currentIndex = this.getBlockIndex(this.selectedBlockUniqueId);

            // Si estamos en el primer bloque de contenido, el anterior es el PDF global
            if (this.blocks[currentIndex]?.uniqueId === contentBlocks[0]?.uniqueId) {
                return this.blocks.find(b => b.isPdfViewerEntry)?.uniqueId || null;
            }

            // Encontrar el índice dentro de los bloques de contenido
            const currentContentIndex = contentBlocks.findIndex(b => b.uniqueId === this.selectedBlockUniqueId);
            if (currentContentIndex > 0) {
                return contentBlocks[currentContentIndex - 1].uniqueId;
            }

            return null; // No hay bloque anterior (o es el PDF global)
        },
        getNextBlockId() {
            const contentBlocks = this.blocks.filter(b => !b.isPdfViewerEntry);
            if (!this.selectedBlockUniqueId || this.blocks.length === 0) return null;

            const currentIndex = this.getBlockIndex(this.selectedBlockUniqueId);

            // Si estamos en el bloque PDF global, el siguiente es el primer bloque de contenido
            if (this.blocks[currentIndex]?.isPdfViewerEntry) {
                return contentBlocks[0]?.uniqueId || null;
            }

            // Encontrar el índice dentro de los bloques de contenido
            const currentContentIndex = contentBlocks.findIndex(b => b.uniqueId === this.selectedBlockUniqueId);
            if (currentContentIndex < contentBlocks.length - 1) {
                return contentBlocks[currentContentIndex + 1].uniqueId;
            }
            return null;
        },
        canNavigateToPreviousBlock() {
            // Si estamos en el bloque PDF global, no podemos ir atrás.
            if (this.selectedBlockUniqueId === this.blocks.find(b => b.isPdfViewerEntry)?.uniqueId) {
                return false;
            }

            // Si estamos en el primer bloque de contenido y en el primer sub-elemento (summary)
            // no podemos navegar hacia atrás
            if (!this.selectedBlockUniqueId || this.blocks.length === 0) return false;

            const firstContentBlock = this.blocks.find(b => !b.isPdfViewerEntry);
            if (!firstContentBlock) return false; // No hay bloques de contenido

            // Si no estamos en el primer subelemento del bloque actual, podemos navegar hacia atrás
            if (this.selectedSubItemType !== 'summary') {
                return true;
            }

            // Si estamos en el primer subelemento (summary) del primer bloque de contenido, no podemos ir hacia atrás
            return this.selectedBlockUniqueId !== firstContentBlock.uniqueId;
        },
        navigateToPreviousBlock() {
            console.log("navigateToPreviousBlock");
            
            // Si estamos en modo "todos los temas", usar navegación especial
            if (this.isAllTopicsMode && this.currentPracticeType) {
                const previousBlock = this.getPreviousBlockInAllTopicsMode();
                if (previousBlock) {
                    console.log(`Navegando al bloque anterior en modo todos: ${previousBlock.name} (${this.currentPracticeType})`);
                    this.selectItem(previousBlock.uniqueId, this.currentPracticeType);
                    return;
                }
            }
            
            if (!this.canNavigateToPreviousBlock()) {
                this.selectPdfViewer();
                return;
            }

            // Si estamos en el primer subelemento (pdf-section) del primer bloque de contenido,
            // navegar al visor de PDF global.
            const firstContentBlock = this.blocks.find(b => !b.isPdfViewerEntry);
            if (this.selectedBlockUniqueId === firstContentBlock?.uniqueId && this.selectedSubItemType === 'pdf-section') {
                this.selectPdfViewer();
                return;
            }

            // Si estamos en el primer subelemento del bloque actual (pdf-section), ir al último 
            // subelemento del bloque anterior (invertir el comportamiento de navigateToNextBlock)
            if (this.selectedSubItemType === 'pdf-section' && this.selectedBlockUniqueId !== firstContentBlock?.uniqueId) {
                const prevBlockId = this.getPreviousBlockId();
                if (prevBlockId) {
                    const prevBlock = this.blocks.find(block => block.uniqueId === prevBlockId);
                    if (prevBlock && prevBlock.subItems && prevBlock.subItems.length > 0) {
                        // Seleccionar el último subelemento del bloque anterior (ahora flashcards)
                        const lastSubItem = prevBlock.subItems[prevBlock.subItems.length - 1];
                        console.log(`Navegando al último subelemento del bloque anterior: ${lastSubItem.type}`);
                        this.selectItem(prevBlockId, lastSubItem.type);
                    }
                    // No debería haber fallback aquí, ya que si hay bloque anterior, debe tener subitems.
                }
                return;
            }

            // Si no estamos en el primer subelemento, ir al anterior dentro del mismo bloque
            const currentBlock = this.blocks.find(block => block.uniqueId === this.selectedBlockUniqueId && !block.isPdfViewerEntry);
            if (currentBlock) {
                // Encontrar el índice del subelemento actual
                const currentSubItemIndex = currentBlock.subItems.findIndex(item => item.type === this.selectedSubItemType);

                // Si hay un subelemento anterior en este bloque, seleccionarlo
                if (currentSubItemIndex > 0) {
                    const previousSubItem = currentBlock.subItems[currentSubItemIndex - 1];
                    console.log(`Navegando al subelemento anterior: ${previousSubItem.type} en el mismo bloque`);
                    this.selectItem(this.selectedBlockUniqueId, previousSubItem.type);
                }
            }
        },
        navigateToNextBlock() {
            // Si estamos en modo "todos los temas", usar navegación especial
            console.log("this.isAllTopicsMode", this.isAllTopicsMode)
            console.log("this.currentPracticeType", this.currentPracticeType)
            if (this.isAllTopicsMode && this.currentPracticeType) {
                const nextBlock = this.getNextBlockInAllTopicsMode();
                if (nextBlock) {
                    console.log(`Navegando al siguiente bloque en modo todos: ${nextBlock.name} (${this.currentPracticeType})`);
                    this.selectItem(nextBlock.uniqueId, this.currentPracticeType);
                    return;
                }
            }
            
            // Comprobar si el próximo bloque está restringido para usuarios no premium
            const nextBlockId = this.getNextBlockId();
            if (nextBlockId) {
                const nextBlock = this.blocks.find(block => block.uniqueId === nextBlockId);
                if (nextBlock && this.hasRestrictedItems(nextBlock) && !this.isPremium && this.selectedSubItemType === 'flashcards') {
                    // Mostrar el diálogo de funcionalidades premium en lugar de navegar
                    this.showFeaturesDialog = true;
                    return;
                }
            }

            // Si estamos en el visor PDF global, ir al primer subitem (pdf-section) del primer bloque de contenido
            const pdfBlock = this.blocks.find(b => b.isPdfViewerEntry);
            if (this.selectedBlockUniqueId === pdfBlock?.uniqueId) {
                const firstContentBlock = this.blocks.find(b => !b.isPdfViewerEntry);
                if (firstContentBlock && firstContentBlock.subItems.length > 0) {
                    // Comprobar si el primer bloque está restringido
                    if (this.hasRestrictedItems(firstContentBlock) && !this.isPremium && this.selectedSubItemType === 'flashcards') {
                        this.showFeaturesDialog = true;
                        return;
                    }
                    this.selectItem(firstContentBlock.uniqueId, firstContentBlock.subItems[0].type); // Selecciona el primer subitem (pdf-section)
                    return;
                }
            }

            // Encontrar el bloque actual
            const currentBlock = this.blocks.find(block => block.uniqueId === this.selectedBlockUniqueId && !block.isPdfViewerEntry);
            if (currentBlock) {
                // Encontrar el índice del subelemento actual
                const currentSubItemIndex = currentBlock.subItems.findIndex(item => item.type === this.selectedSubItemType);

                // Si hay un subelemento siguiente en este bloque, seleccionarlo
                if (currentSubItemIndex !== -1 && currentSubItemIndex < currentBlock.subItems.length - 1) {
                    const nextSubItem = currentBlock.subItems[currentSubItemIndex + 1];
                    console.log(`Navegando al subelemento siguiente: ${nextSubItem.type} en el mismo bloque`);
                    this.selectItem(currentBlock.uniqueId, nextSubItem.type);
                    return;
                }
            }

            // Si estamos en el último subelemento o no se encontró el bloque/subelemento actual,
            // ir al primer subelemento ('summary') del bloque siguiente
            if (nextBlockId) {
                // Siempre empezar con el primer subelemento ('pdf-section') del siguiente bloque
                const nextBlock = this.blocks.find(block => block.uniqueId === nextBlockId);

                // Comprobar si el siguiente bloque está restringido
                if (nextBlock && this.hasRestrictedItems(nextBlock) && !this.isPremium && this.selectedSubItemType === 'flashcards') {
                    this.showFeaturesDialog = true;
                    return;
                }

                const firstSubItemType = nextBlock?.subItems?.[0]?.type || 'pdf-section';
                console.log(`Navegando al primer subelemento (${firstSubItemType}) del bloque siguiente`);
                this.selectItem(nextBlockId, firstSubItemType);
            }
        },
        toggleItemCompletion(blockUniqueId, blockId, subItemType) {
            // No permitir marcar/desmarcar el PDF
            if (subItemType === 'pdf') {
                console.log("El estado de completado del PDF no se puede cambiar manualmente.");
                return;
            }

            // Encontrar el bloque seleccionado
            const blockIndex = this.blocks.findIndex(block => block.uniqueId === blockUniqueId);
            if (blockIndex === -1) return;

            const block = this.blocks[blockIndex];
            const subItemIndex = block.subItems.findIndex(item => item.type === subItemType);
            if (subItemIndex === -1) return;

            // Hacer toggle del estado completado
            const newCompletedState = !block.subItems[subItemIndex].completed;

            // Actualizar la UI
            this.$set(block.subItems[subItemIndex], 'completed', newCompletedState);

            // Enviar al servidor para registrar el progreso
            this.updateUserProgress(blockId, subItemType, newCompletedState);

            // Emitir evento para actualizar la AppBar via Event Bus
            console.log('VIEW: Emitting documentProgressUpdated via EventBus'); // DEBUG
            eventBus.$emit('documentProgressUpdated', { documentId: this.documentId, blocks: this.blocks });
        },
        handleSectionCompleted(eventData) {
            // eventData ahora es un objeto { type, score }
            const sectionType = eventData.type;
            const score = eventData.score;
            console.log(`Received section-completed for type: ${sectionType}, score: ${score}`);

            if (!this.selectedBlockUniqueId || !this.selectedBlockData || !sectionType) return;

            // Actualizar el UI inmediatamente
            const blockIndex = this.blocks.findIndex(block => block.uniqueId === this.selectedBlockUniqueId);
            if (blockIndex === -1) return;

            const block = this.blocks[blockIndex];
            const subItemIndex = block.subItems.findIndex(item => item.type === sectionType);
            if (subItemIndex === -1) return;

            // Marcar como completado en la interfaz
            if (!block.subItems[subItemIndex].completed) {
                this.$set(block.subItems[subItemIndex], 'completed', true);
                // Guardar la puntuación si está disponible
                if (score !== null && score !== undefined) {
                    this.$set(block.subItems[subItemIndex], 'score', score);
                }
                console.log(`Sección ${sectionType} del bloque ${this.selectedBlockData.name} marcada como completada`);
                // Emitir evento para actualizar la AppBar via Event Bus
                console.log('VIEW: Emitting documentProgressUpdated via EventBus'); // DEBUG
                eventBus.$emit('documentProgressUpdated', { documentId: this.documentId, blocks: this.blocks });
            }

            // Si estamos en modo "todos los temas", usar navegación especial
            if (this.isAllTopicsMode && this.currentPracticeType) {
                const nextBlock = this.getNextBlockInAllTopicsMode();
                if (nextBlock) {
                    console.log(`Navegando al siguiente bloque en modo todos: ${nextBlock.name} (${this.currentPracticeType})`);
                    this.selectItem(nextBlock.uniqueId, this.currentPracticeType);
                    return;
                }
            }
        },
        markItemAsCompleted(blockUniqueId, subItemType) {
            console.log('VIEW: Marking item as completed', blockUniqueId, subItemType); // DEBUG
            // Encontrar el bloque seleccionado
            const blockIndex = this.blocks.findIndex(block => block.uniqueId === blockUniqueId);
            if (blockIndex === -1) return;

            const block = this.blocks[blockIndex];
            const subItemIndex = block.subItems.findIndex(item => item.type === subItemType);
            if (subItemIndex === -1) return;

            // Si ya está marcado como completado, no hacer nada
            if (block.subItems[subItemIndex].completed) return;

            // Marcar como completado en la UI con animación
            this.$set(block.subItems[subItemIndex], 'completed', true);

            // Enviar al servidor para registrar el progreso
            this.updateUserProgress(block.id, subItemType, true);

            // Emitir evento para actualizar la AppBar via Event Bus
            console.log('VIEW: Emitting documentProgressUpdated via EventBus'); // DEBUG
            eventBus.$emit('documentProgressUpdated', { documentId: this.documentId, blocks: this.blocks });
        },
        toggleBlock(blockUniqueId) {
            const block = this.blocks.find(b => b.uniqueId === blockUniqueId);

            // Si es el bloque del PDF global, seleccionarlo directamente
            if (block && block.isPdfViewerEntry) {
                this.selectPdfViewer();
                return;
            }

            // Si es un bloque de contenido, expandir/contraer
            const index = this.expandedBlocks.indexOf(blockUniqueId);
            if (index !== -1) {
                // Si ya está expandido, lo contraemos
                this.expandedBlocks.splice(index, 1);
            } else {
                // Si no está expandido, lo expandimos
                this.expandedBlocks.push(blockUniqueId);

                // Autoscroll al bloque expandido
                this.$nextTick(() => {
                    this.scrollToBlock(blockUniqueId);
                });
            }
        },
        scrollToSelectedItem() {
            // No hacer scroll para el PDF global
            const block = this.blocks.find(b => b.uniqueId === this.selectedBlockUniqueId);
            if (!this.selectedBlockUniqueId || !this.selectedSubItemType || (block && block.isPdfViewerEntry)) return;

            // Esperar a que la transición de expansión termine
            setTimeout(() => {
                const itemRef = this.$refs[`item-${this.selectedBlockUniqueId}-${this.selectedSubItemType}`];
                if (itemRef && itemRef[0]) {
                    const container = this.$refs.navBlocksContainer;
                    if (container) {
                        const item = itemRef[0].$el;
                        const itemRect = item.getBoundingClientRect();
                        const containerRect = container.getBoundingClientRect();

                        // Calcular si el elemento está visible en el contenedor
                        if (itemRect.top < containerRect.top || itemRect.bottom > containerRect.bottom) {
                            // Scroll al elemento con animación suave
                            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }
                }
            }, 300); // Esperar a que termine la transición de expansión
        },
        scrollToBlock(blockUniqueId) {
            // No hacer scroll para el PDF global
            const block = this.blocks.find(b => b.uniqueId === blockUniqueId);
            if (block && block.isPdfViewerEntry) return;

            const blockRef = this.$refs[`block-${blockUniqueId}`];
            if (blockRef && blockRef[0]) {
                const container = this.$refs.navBlocksContainer;
                if (container) {
                    const block = blockRef[0].$el;
                    const blockRect = block.getBoundingClientRect();
                    const containerRect = container.getBoundingClientRect();

                    // Calcular si el bloque está visible en el contenedor
                    if (blockRect.top < containerRect.top || blockRect.bottom > containerRect.bottom) {
                        // Scroll al bloque con animación suave
                        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            }
        },
        async updateUserProgress(blockId, contentType, completed = false) {
            try {
                await this.axios.post('/documents/update-progress', {
                    documentId: this.documentId,
                    blockId: blockId,
                    contentType: contentType,
                    completed: completed
                }, {
                    headers: { Authorization: this.$root.token.value }
                });

                console.log(`Progreso actualizado para bloque ${blockId}, tipo ${contentType}: ${completed ? 'completado' : 'pendiente'}`);
            } catch (error) {
                console.error('Error al actualizar el progreso:', error);
                // No revertimos el UI para una mejor experiencia de usuario
            }
        },
        handleScroll(event) {
            const currentScrollTop = event.target.scrollTop;

            // Determinar dirección del scroll
            if (currentScrollTop > this.lastScrollTop + 20) {
                // Scroll hacia abajo - ocultar botones
                this.showFixedNavButtons = false;
                clearTimeout(this.scrollTimeout);
            } else if (currentScrollTop < this.lastScrollTop - 20) {
                // Scroll hacia arriba - mostrar botones
                this.showFixedNavButtons = true;
                clearTimeout(this.scrollTimeout);
            }

            // Actualizar la posición del último scroll
            this.lastScrollTop = currentScrollTop;

            // Establecer un temporizador para mostrar los botones después de que el usuario deje de hacer scroll
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
                this.showFixedNavButtons = true;
            }, 1500);
        },
        selectPdfViewer() {
            const pdfBlock = this.blocks.find(b => b.isPdfViewerEntry);
            if (!pdfBlock) return;

            if (this.$vuetify.breakpoint.xs)
                this.isNavVisible = false

            console.log("Seleccionando vista PDF global");
            this.selectedBlockUniqueId = pdfBlock.uniqueId;
            this.selectedSubItemType = 'pdf'; // Usamos 'pdf' como tipo para el visor

            // Cambiar a la pestaña de contenido al seleccionar el PDF global
            // this.activeTab = 0;

            // Asegurarse de que ningún bloque de contenido esté expandido visualmente como activo
            // (Aunque el PDF es el seleccionado, no queremos que un bloque parezca activo en la lista)

            // Hacer autoscroll al elemento seleccionado en la barra lateral (al bloque PDF)
            this.$nextTick(() => {
                this.scrollToBlock(pdfBlock.uniqueId); // Aunque lo deshabilitemos, puede ser útil si la lista es larga
                // Scroll del contenido principal al inicio
                const contentArea = this.$el.querySelector('.document-content-area .v-main__wrap');
                if (contentArea) {
                    contentArea.scrollTop = 0;
                }
            });
        },
        getBlockContentIndex(blockUniqueId) {
            // Devuelve el índice basado solo en los bloques de contenido
            return this.blocks.filter(b => !b.isPdfViewerEntry).findIndex(b => b.uniqueId === blockUniqueId);
        },
        getBlockProgress(block) {
            if (!block || block.isPdfViewerEntry || !block.subItems) {
                return '0 / 0'; // O manejar como prefieras
            }
            const completedCount = block.subItems.filter(item => item.completed).length;
            const totalCount = block.subItems.length;
            const totalEstimatedTime = block.subItems.reduce((acc, item) => acc + (item.estimatedTime || 0), 0) + Math.round(block.audioDuration / 60);

            let progressString = `${completedCount} / ${totalCount}`;
            if (totalEstimatedTime > 0) {
                progressString += `   |   ${this.formatEstimatedTime(totalEstimatedTime)}`;
            }
            return progressString;
        },
        getBlockProgressPercentage(block) {
            if (!block || block.isPdfViewerEntry || !block.subItems) {
                return 0;
            }
            const completedCount = block.subItems.filter(item => item.completed).length;
            const totalCount = block.subItems.length;
            return (completedCount / totalCount) * 100;
        },
        formatEstimatedTime(minutes) {
            if (minutes === null || minutes === undefined || minutes === 0) {
                return '';
            }
            if (minutes < 60) {
                return `${minutes}min`;
            }
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            if (remainingMinutes === 0) {
                return `${hours}h`;
            }
            return `${hours}h ${remainingMinutes}min`;
        },
        askSuggestion(question) {
            this.chatInput = question;
            this.sendChatMessage();
        },
        async sendChatMessage() {
            if (!this.chatInput.trim() || this.isAiResponding) return;

            this.activeTab = 1

            if (!this.isNavVisible)
                this.isNavVisible = true

            setTimeout(() => {

                // Obtener referencia al componente AIChatAssistant
                const aiChatAssistant = this.$refs.aiChatAssistant;

                if (aiChatAssistant) {
                    // Pasar la pregunta al componente de chat y cambiar a esa pestaña
                    const question = this.chatInput.trim();
                    this.chatInput = ''; // Limpiar el input

                    // Cambiar a la pestaña de chat
                    this.activeTab = 1;

                    // Marcar como respondiendo mientras se procesa
                    this.isAiResponding = true;

                    // Enviar la pregunta al componente de chat
                    this.$nextTick(() => {
                        aiChatAssistant.sendGenericMessage(question)
                            .then(() => {
                                // Una vez completado, actualizar el estado
                                this.isAiResponding = false;
                            })
                            .catch(error => {
                                console.error('Error al enviar mensaje:', error);
                                this.isAiResponding = false;
                                this.$toast.error('Error al enviar mensaje');
                            });
                    });
                } else {
                    this.$toast.error('Error al conectar con el asistente de chat.');
                }
            }, 500)
        },
        scrollToChatBottom() {
            this.$nextTick(() => {
                const container = this.$el.querySelector('.chat-messages-container');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        startResize(e) {
            this.resizing = true;
            document.body.style.cursor = 'col-resize';
            e.preventDefault();
        },
        handleResize(e) {
            if (!this.resizing) return;

            // Calcular el nuevo ancho basado en la posición del ratón
            // Como el drawer está a la derecha, el ancho es la distancia desde el borde derecho
            const newWidth = Math.max(300, window.innerWidth - e.clientX);
            this.navDrawerWidth = Math.min(800, newWidth); // Limitar entre 300 y 800px
        },
        stopResize() {
            this.resizing = false;
            document.body.style.cursor = 'default';
        },
        isValidJson(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        },
        dismissGenerationDialog() {
            // Guardar en cookie que el usuario ha cerrado el diálogo para este documento
            const cookieKey = `study_dialog_dismissed_${this.documentId}`;
            this.$cookies.set(cookieKey, true, '30d'); // Cookie válida por 30 días
            this.showGenerationCompleteDialog = false;
        },
        startIntelligentStudy() {
            // Guardar en cookie que el usuario ha iniciado el estudio para este documento
            const cookieKey = `study_dialog_dismissed_${this.documentId}`;
            this.$cookies.set(cookieKey, true, '30d'); // Cookie válida por 30 días

            // Cierra el diálogo
            this.showGenerationCompleteDialog = false;

            // Navega al primer bloque de contenido con el estudio inteligente
            this.navigateToNextBlock();
        },
        hasRestrictedItems(block) {
            return block.subItems && block.subItems.some(item => block.isAccessible === false);
        },
        handleWindowResize() {
            // Ocultar el panel de navegación automáticamente en dispositivos móviles
            // if (window.innerWidth < 960 && this.isNavVisible) {
            //     this.isNavVisible = false;
            //     localStorage.setItem('documentNavVisible', 'false');
            // }
        },
        navigateToDocPage(pageNumber) {
            // Seleccionar primero la vista de PDF si no está seleccionada
            if (this.selectedSubItemType !== 'pdf') {
                this.selectPdfViewer();
            }

            // Asegurarnos de que el visor de PDF está accesible
            this.$nextTick(() => {
                // Obtener referencia al componente PdfViewerBlock y llamar a su método goToPage
                if (this.$refs.pdfViewerBlock) {
                    this.$refs.pdfViewerBlock.goToPage(parseInt(pageNumber, 10));
                    console.log(`Navegando a la página ${pageNumber} del documento`);
                } else {
                    console.error('No se pudo acceder al visor de PDF');
                    this.$toast.error('No se pudo navegar a la página del documento');
                }
            });
        },
        handleEnterKey(event) {
            if (event.shiftKey) return;
            this.sendChatMessage();
        },
        filterDocument(event) {
            console.log('filterDocument', event);
        },
        toggleGenerationCompleteDialog() {
            this.showGenerationCompleteDialog = !this.showGenerationCompleteDialog;
        },
        // El método fetchBlockSummary ya no es necesario porque hemos reemplazado 'summary' por 'pdf-section'
        clearSelection() {
            this.selectedBlockUniqueId = null;
            this.selectedSubItemType = null;
            // No borramos los expandedBlocks para mantener el estado de expansión
        },
        /**
         * Carga la explicación del profesor para un bloque específico
         */
        async loadTeacherExplanation(blockId) {
            if (!blockId) return;

            this.loadingTeacherExplanation = true;
            this.teacherExplanationContent = '';
            this.teacherExplanationAudio = '';

            try {
                console.log(`Cargando explicación del profesor para el bloque ID ${blockId}...`);
                const response = await this.axios.get(`/blocks/${blockId}/teacher-explanation`, {
                    headers: { Authorization: this.$root.token.value }
                });

                if (response.data.success && response.data.explanation) {
                    console.log('Explicación del profesor cargada con éxito');
                    this.teacherExplanationContent = response.data.explanation.content;
                    this.teacherExplanationAudio = response.data.explanation.audioUrl;

                    // Guardar en caché
                    const cacheKey = `teacher-explanation-${blockId}`;
                    this.contentCache[cacheKey] = {
                        content: response.data.explanation.content,
                        audioUrl: response.data.explanation.audioUrl
                    };
                } else {
                    console.log('No se encontró explicación del profesor para este bloque');
                    this.teacherExplanationContent = '';
                    this.teacherExplanationAudio = '';
                }
            } catch (error) {
                console.error('Error al cargar la explicación del profesor:', error);
                this.teacherExplanationContent = '';
                this.teacherExplanationAudio = '';
            } finally {
                this.loadingTeacherExplanation = false;
            }
        },
        // Identificar bloques en generación después de cargar la estructura
        trackGeneratingBlocks() {
            // Limpiar los bloques en generación previos
            this.generatingBlockIds = [];

            // Identificar bloques que están en generación
            this.blocks.forEach(block => {
                if (block.isGenerating && block.id) {
                    this.generatingBlockIds.push(block.id);
                }
            });

            console.log(`Encontrados ${this.generatingBlockIds.length} bloques en generación activa`);

            // Si hay bloques en generación, iniciar el intervalo de verificación
            if (this.generatingBlockIds.length > 0) {
                this.startGenerationCheckInterval();
            } else {
                this.stopGenerationCheckInterval();
            }
        },

        // Iniciar el intervalo para verificar el estado de los bloques
        startGenerationCheckInterval() {
            // Detener el intervalo existente si hay uno
            this.stopGenerationCheckInterval();

            console.log('Iniciando verificación periódica de estado de bloques en generación');

            // Crear nuevo intervalo que verificará cada 30 segundos
            this.generationCheckInterval = setInterval(() => {
                this.checkGeneratingBlocksStatus();
            }, 30000); // 30 segundos
        },

        // Detener el intervalo de verificación
        stopGenerationCheckInterval() {
            if (this.generationCheckInterval) {
                clearInterval(this.generationCheckInterval);
                this.generationCheckInterval = null;
            }
        },

        // Verificar el estado actual de los bloques en generación
        async checkGeneratingBlocksStatus() {
            if (this.generatingBlockIds.length === 0) {
                this.stopGenerationCheckInterval();
                return;
            }

            console.log(`Verificando estado de ${this.generatingBlockIds.length} bloques en generación...`);

            try {
                // Obtener estado de todos los bloques del documento es más eficiente que consultas individuales
                const response = await this.axios.get(`/documents/${this.documentId}/blocks-status`, {
                    headers: { Authorization: this.$root.token.value }
                });

                if (response.data.success && response.data.blocks) {
                    let updatedBlocks = false;
                    let stillGeneratingBlocks = [];

                    // Procesar cada bloque del documento
                    response.data.blocks.forEach(serverBlock => {
                        // Solo procesar bloques que estábamos rastreando como en generación
                        if (this.generatingBlockIds.includes(serverBlock.blockId)) {

                            // Encontrar el bloque en nuestra estructura local
                            const blockIndex = this.blocks.findIndex(b => b.id === serverBlock.blockId);

                            if (blockIndex !== -1) {
                                const localBlock = this.blocks[blockIndex];

                                // Actualizar el estado de generación si cambió
                                if (localBlock.isGenerating !== serverBlock.isGenerating ||
                                    localBlock.generated !== serverBlock.generated) {

                                    console.log(`El estado del bloque ${serverBlock.blockId} cambió - isGenerating: ${serverBlock.isGenerating}, generated: ${serverBlock.generated}`);

                                    // Actualizar propiedades locales
                                    this.$set(this.blocks[blockIndex], 'isGenerating', serverBlock.isGenerating);
                                    this.$set(this.blocks[blockIndex], 'generated', serverBlock.generated);

                                    // Actualizar el estado de los subitems si se completó la generación
                                    if (serverBlock.generated && !serverBlock.isGenerating) {
                                        this.blocks[blockIndex].subItems.forEach((item, idx) => {
                                            this.$set(this.blocks[blockIndex].subItems[idx], 'generated', true);
                                        });
                                    }

                                    updatedBlocks = true;
                                }

                                // Si el bloque sigue en generación, mantenerlo en la lista de seguimiento
                                if (serverBlock.isGenerating) {
                                    stillGeneratingBlocks.push(serverBlock.blockId);
                                }
                            }
                        }
                    });

                    // Actualizar la lista de bloques en generación
                    this.generatingBlockIds = stillGeneratingBlocks;

                    // Si todos los bloques han terminado, detener el intervalo
                    if (this.generatingBlockIds.length === 0) {
                        console.log('Todos los bloques han completado la generación');
                        this.stopGenerationCheckInterval();
                    }

                    // Si hubo cambios, podríamos querer actualizar la UI o enviar eventos
                    if (updatedBlocks) {
                        // Emitir evento para actualizar la AppBar via Event Bus
                        console.log('Emitiendo documentProgressUpdated para reflejar cambios en bloques');
                        eventBus.$emit('documentProgressUpdated', {
                            documentId: this.documentId,
                            blocks: this.blocks
                        });
                    }
                }
            } catch (error) {
                console.error('Error al verificar el estado de los bloques:', error);
            }
        },
        selectBottomNavItem(item) {
            if (item === 'home') {
                this.bottomNavSelected = 'home';
                this.selectPdfViewer();
                return;
            }
            
            this.bottomNavSelected = item;
            this.selectedPracticeType = item;
            console.log("this.selectedPracticeType", this.selectedPracticeType)
            
            // Cargar bloques disponibles para selección
            this.loadAvailableBlocks();
            
            this.showPracticeModeDialog = true;
        },
        closePracticeModeDialog() {
            this.showPracticeModeDialog = false;
            this.selectedPracticeMode = 'all';
            this.selectedSpecificBlock = null;
            this.bottomNavSelected = 'home';
            // Resetear modo "todos los temas" al cerrar el diálogo
            this.isAllTopicsMode = false;
            this.currentPracticeType = null;
        },
        selectPracticeMode(mode) {
            this.selectedPracticeMode = mode;
        },
        loadAvailableBlocks() {
            // Filtrar solo los bloques de contenido (no el PDF viewer)
            this.availableBlocks = this.blocks.filter(block => !block.isPdfViewerEntry).map(block => ({
                ...block,
                isAccessible: block.isAccessible !== false // Asegurar que los bloques sin esta propiedad sean accesibles
            }));
        },
        startPracticeSession() {
            if (this.selectedPracticeMode === 'all') {
                this.startAllTopicsPractice();
            } else if (this.selectedPracticeMode === 'specific' && this.selectedSpecificBlock) {
                this.startSpecificTopicPractice();
            }
            // this.closePracticeModeDialog();
            this.showPracticeModeDialog = false;
        },
        startAllTopicsPractice() {
            // Lógica para practicar todos los temas
            const practiceType = this.selectedPracticeType;
            console.log(`Iniciando práctica de todos los temas: ${practiceType}`);
            
            // Activar modo "todos los temas"
            this.isAllTopicsMode = true;
            this.currentPracticeType = practiceType;
            
            // Obtener todos los bloques accesibles
            const accessibleBlocks = this.blocks.filter(block => 
                !block.isPdfViewerEntry && 
                block.isAccessible !== false &&
                block.generated
            );
            
            if (accessibleBlocks.length === 0) {
                this.$toast.warning('No hay contenido disponible para practicar');
                this.isAllTopicsMode = false;
                this.currentPracticeType = null;
                return;
            }
            
            // Si es usuario no premium y hay bloques restringidos, mostrar mensaje
            if (!this.isPremium) {
                const restrictedBlocks = this.blocks.filter(block => 
                    !block.isPdfViewerEntry && 
                    block.isAccessible === false
                );
                
                if (restrictedBlocks.length > 0) {
                    this.$toast.info(`Practicando con ${accessibleBlocks.length} temas disponibles. Hazte Premium para acceder a todos los temas.`);
                }
            }
            
            // Navegar al primer bloque disponible con el tipo seleccionado
            const firstBlock = accessibleBlocks[0];
            this.selectItem(firstBlock.uniqueId, practiceType);
            
            // Mensaje de confirmación
            // this.$toast.success(`Iniciando ${this.getPracticeTypeTitle(practiceType).toLowerCase()} de todos los temas`);
        },
        startSpecificTopicPractice() {
            const practiceType = this.selectedPracticeType;
            const blockUniqueId = this.selectedSpecificBlock;
            
            console.log(`Iniciando práctica específica: ${practiceType} del bloque ${blockUniqueId}`);
            
            // Desactivar modo "todos los temas" ya que es práctica específica
            this.isAllTopicsMode = false;
            this.currentPracticeType = null;
            
            // Verificar si el bloque está disponible
            const selectedBlock = this.blocks.find(block => block.uniqueId === blockUniqueId);
            
            if (!selectedBlock) {
                this.$toast.error('El tema seleccionado no está disponible');
                return;
            }
            
            // Verificar accesibilidad para usuarios no premium
            if (!this.isPremium && selectedBlock.isAccessible === false) {
                this.showFeaturesDialog = true;
                this.$toast.warning('Este tema requiere una suscripción Premium');
                return;
            }
            
            // Navegar al bloque específico con el tipo seleccionado
            this.selectItem(blockUniqueId, practiceType);
            
            // Mensaje de confirmación
            this.$toast.success(`Iniciando ${this.getPracticeTypeTitle(practiceType).toLowerCase()} del tema: ${selectedBlock.name}`);
        },
        getPracticeTypeIcon(type) {
            switch (type) {
                case 'explanation':
                    return 'mdi-account-voice';
                case 'quiz':
                    return 'mdi-help-circle-outline';
                case 'flashcards':
                    return 'mdi-cards-outline';
                default:
                    return 'mdi-file-pdf-box';
            }
        },
        getPracticeTypeTitle(type) {
            switch (type) {
                case 'explanation':
                    return 'Explicación con Audio';
                case 'quiz':
                    return 'Cuestionarios';
                case 'flashcards':
                    return 'Tarjetas de Repaso';
                default:
                    return 'PDF';
            }
        },
        // Función auxiliar para encontrar el siguiente bloque en modo "todos los temas"
        getNextBlockInAllTopicsMode() {
            if (!this.isAllTopicsMode || !this.currentPracticeType) return null;
            
            // Obtener todos los bloques accesibles y generados
            const accessibleBlocks = this.blocks.filter(block => 
                !block.isPdfViewerEntry && 
                block.isAccessible !== false &&
                block.generated
            );
            
            // Encontrar el índice del bloque actual
            const currentIndex = accessibleBlocks.findIndex(block => 
                block.uniqueId === this.selectedBlockUniqueId
            );
            
            // Si estamos en el último bloque, volver al primero
            if (currentIndex === accessibleBlocks.length - 1) {
                return accessibleBlocks[0];
            }
            
            // Si no estamos en el último, ir al siguiente
            if (currentIndex !== -1 && currentIndex < accessibleBlocks.length - 1) {
                return accessibleBlocks[currentIndex + 1];
            }
            
            return null;
        },
        // Función auxiliar para encontrar el bloque anterior en modo "todos los temas"
        getPreviousBlockInAllTopicsMode() {
            if (!this.isAllTopicsMode || !this.currentPracticeType) return null;
            
            // Obtener todos los bloques accesibles y generados
            const accessibleBlocks = this.blocks.filter(block => 
                !block.isPdfViewerEntry && 
                block.isAccessible !== false &&
                block.generated
            );
            
            // Encontrar el índice del bloque actual
            const currentIndex = accessibleBlocks.findIndex(block => 
                block.uniqueId === this.selectedBlockUniqueId
            );
            
            // Si estamos en el primer bloque, ir al último
            if (currentIndex === 0) {
                return accessibleBlocks[accessibleBlocks.length - 1];
            }
            
            // Si no estamos en el primero, ir al anterior
            if (currentIndex > 0) {
                return accessibleBlocks[currentIndex - 1];
            }
            
            return null;
        }
    }
};
</script>



<style scoped>
.dialog-generation-complete>>>.v-dialog {
    overflow-y: hidden !important;
}

.toggle-nav-btn {
    position: fixed;
    top: 10px;
    width: 50px;
    z-index: 1000;
    border-radius: 8px 0 0 8px !important;
    transition: none;
}

.document-view-container {
    display: flex;
    background-color: white;
    /* Make sure the container can fill height */
    height: 100vh;
    overflow: hidden;
    /* Prevent scroll on the main container */
}

.document-content-area {
    flex-grow: 1;
    overflow-y: auto;
    /* Allow content area to scroll if needed, but fill height */
    display: flex;
    flex-direction: column;
    transition: none;
}

.content-wrapper {
    /* Allow wrapper to grow and enable fill-height */
    display: flex;
    flex-direction: column;
}

.content-container {
    width: 100%;
    /* Allow container to grow */
    flex: 1;
}

.content-header {
    background-color: white;
    /* Espacio para los botones fijos */
    max-width: 900px;
    margin: 0 auto;
}

.content-tools {
    margin-bottom: 8px;
}

.item-type {
    display: flex;
    align-items: center;
    margin-right: 15px;
    background-color: #f7f7f7;
    padding: 4px 10px;
    border-radius: 12px;
}

.dotted-bg {
    background-color: #F6F5F1;
    opacity: 1;
    background-image: radial-gradient(#cddecd 1px, #ECF8ED 1px);
    background-size: 20px 20px;
    background-repeat: repeat;
}

.content-card {
    overflow: hidden;
    background-color: white;
    /* Espacio para los botones fijos */
}

.document-nav-drawer {
    padding-top: 0;
    transition: none;
}

.document-title {
    padding: 10px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.block-section-item {
    background-color: #fbfbfb;
}

.nav-blocks-container {
    overflow-y: scroll;
    height: 100%;
    /* Occupy full available height */
    scrollbar-width: thin;
    scrollbar-color: #ccc #f1f1f1;
    padding-bottom: 64px;
}

.nav-blocks-container::-webkit-scrollbar {
    width: 6px;
}

.nav-blocks-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.nav-blocks-container::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.nav-blocks-container::-webkit-scrollbar-thumb:hover {
    background: #aaa;
}

.nav-blocks-container::-webkit-scrollbar-thumb:hover {
    background: #4dd453 !important;
    padding-right: 24px !important;
    box-shadow: 0 4px 0 #42b848 !important;
    color: white !important;
}

.nav-block-card {
    transition: all 0.2s ease-in-out;
    border-bottom: 1px solid #e3e3e3 !important;
    background-color: white;
    cursor: pointer;
    overflow: hidden;
}



.nav-block-card .v-card__title {
    padding: 12px 16px !important;
    min-height: 48px;
}

.nav-subitem {
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    box-shadow: none !important;
    position: relative;
    overflow: hidden;
}

.nav-subitem.subitem-restricted {
    /* Styles for the card itself when restricted, if needed beyond overlay */
    /* e.g., could have a more pronounced border or a slightly different bg */
}

.restricted-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 5;
    /* Ensure it's above other subitem content */
    padding: 10px;
    text-align: center;
    color: white;
    cursor: pointer;
    /* So the click to open dialog works on the overlay */
}

.restricted-overlay p {
    font-size: 0.8rem;
    margin-bottom: 8px;
}

.restricted-overlay .v-btn {
    text-transform: none;
    font-size: 0.8rem;
}

.nav-subitem:hover {
    background-color: #f0f0f0;
}

.nav-subitem:hover::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background-color: rgba(76, 175, 80, 0.4);
    animation: slideIn 0.2s ease-out forwards;
}

@keyframes slideIn {
    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0);
    }
}

.nav-subitem-active {
    background-color: rgb(105 156 107 / 10%) !important;
    color: #2e7d32 !important;
}

.nav-subitem-active .v-icon {
    color: #2e7d32 !important;
}

/* Animaciones */
.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
    transition-duration: 0s;
    transition-timing-function: linear;
}

/* Estilos para los checkboxes */
.checkbox-container {
    width: 18px;
    min-width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 2px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.checkbox-container:hover {
    border-color: #4CAF50;
    transform: scale(1.05);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.checkbox-container:active {
    transform: scale(0.95);
}

.checkbox-container::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(76, 175, 80, 0.2);
    border-radius: 3px;
    opacity: 0;
    transform: scale(0);
    transition: all 0.3s ease;
}

.checkbox-container:active::after {
    opacity: 1;
    transform: scale(1.5);
    transition: all 0.1s ease;
}

.checkbox-completed {
    background-color: #4CAF50;
    border-color: #4CAF50;
}

.checkbox-completed .v-icon {
    animation: scaleIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes scaleIn {
    0% {
        transform: scale(0);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Asegurarse de que el checkbox no afecte a la selección del elemento */
.checkbox-container * {
    pointer-events: none;
}

.breadcrumb {
    font-size: 0.9rem;
    border-radius: 8px !important;
    width: 100%;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    padding: 4px 12px !important;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(3px);
}

.action-button {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 500 !important;
    border-radius: 10px !important;
    padding: 0 16px !important;
    height: 40px !important;
}

/* Estilos para los botones de navegación fijos */
.fixed-navigation-buttons {
    position: fixed;
    bottom: 20px;
    left: calc(50% - 250px);
    /* Ajustar por el drawer lateral */
    transform: translateX(-50%);
    z-index: 100;
    display: flex;
    justify-content: space-between;
    width: 90%;
    max-width: 800px;
    background-color: transparent;
    transition: transform 0.4s ease, opacity 0.4s ease;
}

.fixed-nav-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 500 !important;
    min-width: 120px;
    border-radius: 10px !important;
    /* box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1) !important; */
    opacity: 0.95;
    transition: all 0.3s ease;
    height: 42px !important;
    margin: 0 10px;
}

.fixed-nav-btn-prev {
    background-color: white !important;
}

.fixed-nav-btn-next {
    background-color: #4CAF50 !important;
    color: white !important;
}

.fixed-nav-hidden {
    transform: translateX(-50%) translateY(100px);
    opacity: 0;
    pointer-events: none;
}

@media (max-width: 1264px) {
    .fixed-navigation-buttons {
        /* left: 0; */
        width: calc(100% - 550px);
        /* Ajustar para el ancho del drawer */
        transform: translateX(-50%);
    }
}

@media (max-width: 960px) {
    .document-nav-drawer {
        position: fixed !important;
    }

    .mx-auto.d-flex.flex-column.align-start {
        max-width: 100%;
        padding-left: 16px;
        padding-right: 16px;
    }

    .breadcrumb {
        max-width: 100%;
        margin-top: 8px !important;
        border-radius: 0 !important;
    }

    .d-flex.align-start.pb-8.px-3 {
        padding: 16px !important;
        flex-direction: column;
        align-items: center !important;
    }

    .d-flex.align-start.pl-5.pt-4 {
        padding: 16px 0 0 0 !important;
        flex-direction: column;
        align-items: center !important;
        width: 100%;
    }

    .d-flex.align-start.pl-5.pt-4>div:first-child {
        text-align: center;
        margin-bottom: 16px;
    }

    .d-flex.align-start.pl-5.pt-4>.v-btn {
        margin-bottom: 8px;
    }

    .text-h5 {
        font-size: 1.25rem !important;
    }



    .fixed-navigation-buttons {
        width: 95%;
        padding: 10px 15px;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
    }

    .fixed-nav-btn {
        min-width: 100px;
    }
}

@media (max-width: 600px) {
    .fixed-navigation-buttons {
        width: 100%;
        border-radius: 0;
        bottom: 0;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    }

    .fixed-nav-btn {
        flex-grow: 1;
        min-width: auto;
        padding: 0 8px !important;
    }
}

.document-nav-drawer>>>.v-navigation-drawer__content {
    overflow-y: hidden;
}

.document-nav-drawer .v-navigation-drawer__content::-webkit-scrollbar {
    width: 6px;
}

.document-nav-drawer .v-navigation-drawer__content::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.document-nav-drawer .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.document-nav-drawer .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background: #aaa;
}

.document-nav-drawer .v-navigation-drawer__content {
    scrollbar-width: thin;
    scrollbar-color: #ccc #f1f1f1;
}

/* Estilos para evitar selección en el navbar */
.document-nav-drawer {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}


.primary-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 800 !important;
    font-size: 0.9rem !important;
    height: 38px !important;
    border-radius: 12px !important;
    border: 2px solid #4dd453 !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
    background: #4dd453 !important;
    box-shadow: 0 4px 0 #42b848 !important;
    color: white !important;
}

/* Estilos para el contenedor del Asistente IA */
.ai-assistant-container {
    height: 100%;
    /* Asegurar que ocupe toda la altura del tab-item */
}

/* Ajustes para v-tabs-items */
.v-tabs-items {
    height: calc(100% - 48px);
    /* Ajustar altura para dejar espacio a las tabs (48px es altura estándar) */
}

.v-tab-item {
    height: 100%;
    overflow-y: auto;
    /* Permitir scroll si el contenido excede */
}

.suggestion-chip {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.suggestion-chip:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.input-area .v-textarea>>>.v-input__slot {
    margin-bottom: 0 !important;
    /* Evitar espacio extra debajo del textarea */
}

/* Estilos para las pestañas personalizadas */
.custom-tabs {
    border-radius: 0;
}


.active-tab {
    opacity: 1;
}

.tab-text {
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
}



.custom-tabs-items {}

/* Estilos para el chat */
.chat-messages-container {
    padding: 0 4px;
}

.chat-messages {
    padding-bottom: 16px;
}

.chat-message {
    max-width: 85%;
    border-radius: 12px;
}

.user-message {
    margin-left: auto;
}

.ai-message {
    margin-right: auto;
}

.message-content {
    background-color: #f0f0f0;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.user-message .message-content {
    background-color: #e3f2fd;
}

.ai-message .message-content {
    background-color: white;
    border: 1px solid #e0e0e0;
}

/* Animación simple de aparición de mensajes */
.message-fade-enter-active,
.message-fade-leave-active {
    transition: opacity 0.2s ease;
}

.message-fade-enter,
.message-fade-leave-to {
    opacity: 0;
}

/* Estilos para los chips de sugerencias - simples */
.suggestion-chip {
    margin: 4px;
    border-radius: 24px !important;
    font-size: 0.85rem !important;
    padding: 6px 12px !important;
}

.suggestion-chip:hover {
    background-color: #f5f5f5 !important;
}

.send-button {
    transition: all 0.3s ease;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    background-color: #4dd453 !important;
}

.document-nav-drawer>>>.v-window__container {
    height: 100% !important;
}

.send-button:hover:not(:disabled) {
    background-color: #3aa44a !important;
}

/* Animación de pulso para el botón de enviar */
@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(77, 212, 83, 0.5);
    }

    70% {
        box-shadow: 0 0 0 8px rgba(77, 212, 83, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(77, 212, 83, 0);
    }
}

.pulse-animation {
    animation: pulse 1.5s infinite;
}

/* Mejoras adicionales para consistencia */
.question-suggestions {
    padding: 8px 12px;
    text-align: center;
}

.drawer-resize-handle {
    position: absolute;
    left: 0;
    top: 0;
    width: 6px;
    height: 100%;
    cursor: col-resize;
    z-index: 1000;
}

.drawer-resize-handle:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

/* Estilos para v-progress-circular dentro del checkbox */
.checkbox-container .progress-icon {
    position: absolute;
    top: -1px;
    /* Ajuste fino para centrar visualmente */
    left: -1px;
    /* Ajuste fino para centrar visualmente */
}

.checkbox-container .progress-text {
    font-size: 8px;
    /* Tamaño pequeño para que quepa */
    font-weight: bold;
    color: white;
}

/* Asegurarse que el v-icon original no interfiera si ambos se renderizan */
.checkbox-container .v-icon {
    position: relative;
    /* Para asegurar que esté por encima si es necesario */
    z-index: 1;
}

.regular-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 600 !important;
    font-size: 0.95rem !important;
    border-radius: 12px !important;
    transition: filter 0.2s ease, transform 0.1s ease !important;
    border: 1px solid #e0e0e0 !important;
    height: 38px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
    background-color: white !important;
    box-shadow: 0 4px 0 #b5b5b5 !important;
    color: #424242 !important;
}

.regular-btn-primary {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 600 !important;
    font-size: 0.95rem !important;
    border-radius: 12px !important;
    transition: filter 0.2s ease, transform 0.1s ease !important;
    border: 1px solid #4dd453 !important;
    height: 38px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
    background-color: #4dd453 !important;
    box-shadow: 0 4px 0 #42b848 !important;
    color: white !important;
}

.nav-subitem-disabled {
    opacity: 0.6;
    pointer-events: none;
    /* This might be too aggressive if we want the overlay button to be clickable */
    /* We will handle clickability via the :disabled prop and the overlay's own click handler. */
}

.section-restriction-notice {
    margin: 10px 15px;
    padding: 10px;
    background-color: #f8f8f8;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-restriction-notice p {
    color: #555;
    margin-bottom: 10px;
}

.limit-exceeded-alert {
    max-width: 600px;
    margin: 0 auto;
}

.nav-block-disabled {
    opacity: 0.7;
    position: relative;
    background-color: #f9f9f9;
    border-left: 3px solid #ffa726 !important;
}

.nav-block-disabled::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 1;
}

.nav-block-disabled::before {
    content: "Límite alcanzado";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.7rem;
    color: #ff9800;
    font-weight: bold;
    z-index: 2;
    pointer-events: none;
}

.limit-exceeded-sidebar {
    background-color: #fff8e1;
    border-radius: 8px;
    margin: 10px;
    border: 1px solid #ffcc80;
}

.limit-exceeded-sidebar h3 {
    color: #f57c00;
    font-size: 1.1rem;
}

.limit-exceeded-sidebar p {
    color: #5d4037;
    font-size: 0.9rem;
}

.premium-benefits {
    padding: 8px;
    border-radius: 6px;
    background-color: rgba(255, 248, 225, 0.5);
}

.benefit-text {
    font-size: 0.85rem;
    color: #5d4037;
}

.limit-exceeded-sidebar .v-btn {
    background-color: #ffa726;
    color: white;
}


.blur-effect {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(to top, 
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 255, 255, 0.9) 20%,
    rgba(255, 255, 255, 0.85) 40%,
    rgba(255, 255, 255, 0.8) 60%,
    rgba(255, 255, 255, 0.65) 80%,
    rgba(255, 255, 255, 0.5) 100%
  );
  mask-image: linear-gradient(to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.8) 20%,
    rgba(0, 0, 0, 0.6) 40%,
    rgba(0, 0, 0, 0.4) 60%,
    rgba(0, 0, 0, 0.2) 80%,
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.8) 20%,
    rgba(0, 0, 0, 0.6) 40%,
    rgba(0, 0, 0, 0.4) 60%,
    rgba(0, 0, 0, 0.2) 80%,
    rgba(0, 0, 0, 0) 100%
  );
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  pointer-events: none;
  z-index: 7 !important;
}

/* Estilos para la barra de navegación inferior tipo Instagram */
.bottom-navigation-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 1000;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
}

.bottom-nav-mobile {
  height: 65px;
}

.bottom-nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 400px;
  padding: 0 20px;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  min-width: 70px;
}

.bottom-nav-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: scale(1.05);
}

.bottom-nav-item.nav-item-active {
  background-color: rgba(25, 118, 210, 0.1);
  transform: scale(1.08);
}

.bottom-nav-item.nav-item-active::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background-color: #1976d2;
  border-radius: 2px;
}

.nav-item-label {
  font-size: 10px;
  font-weight: 600;
  margin-top: 4px;
  color: #666;
  transition: color 0.2s ease;
  text-align: center;
  line-height: 1;
}

.bottom-nav-item.nav-item-active .nav-item-label {
  color: #1976d2;
}

.bottom-nav-item .v-icon {
  transition: all 0.2s ease;
}

.bottom-nav-item:active {
  transform: scale(0.95);
}

/* Animaciones suaves */
@keyframes bottomNavSlideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.bottom-navigation-bar {
  animation: bottomNavSlideIn 0.3s ease-out;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .bottom-nav-container {
    padding: 0 10px;
  }
  
  .bottom-nav-item {
    min-width: 60px;
    padding: 6px 8px;
  }
  
  .nav-item-label {
    font-size: 9px;
  }
}

</style>

